/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

(function (window, undefined) {
  'use strict';
  angular.module('cbl.cartadebitoint.wa').constant('CDINT_CONSTANTS', {
    BASE_ROOT: '/CBL-CARTADEBITOINT-WA/app/',
    REST_ROOT: '/CBL-CARTADEBITOINT-MF/services/api-',
    REST_CLIENTI_ROOT: '/MSF-CUSTOMERDATA-MF/api/',
    REST_PROSPECTMANAGER_ROOT: '/MSF-PROSPECTMANAGER-MF/',
    COMPONENTS_PATH: 'components/',
    NAZIONE_SPEDIZIONE_DEFAULT: '086',
    //API
    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        FIELDCONFIGURATOR: 'generale/fieldConfigurator/' // generale/fieldConfigurator/:nomeConfigurazione
      },
      ANAGRAFICA: {
        DETTAGLIO: 'anagrafica/anagrafica/', // anagrafica/:idPratica
        DETTAGLIO_ANA: 'anagrafica/anagrafica/recuperaAnagrafica/', // anagrafica/:ndg
        DETTAGLIO_COI: 'anagrafica/anagrafica/recuperaListaNdgPerCoi/' // anagrafica/:ndg
      },
      DOCUMENTO: {
        ENTE_RILASCIO: 'documento/enterilascio'
      },
      TIPO_CARTA: 'cpt/tipoCarta/', //generale/tipocarta/:idProdotto
      TIPO_CARTA_PER_ID: 'cpt/prodotto/', //generale/tipocarta/:idPratica
      DOMINI: 'generale/domini/', // generale/domini//:codiceDominio
      PRATICA: {
        CREA: 'pratica/pratica',
        DETTAGLIO: 'pratica/pratica/', // pratica/:idPratica
        CONTOCORRENTE: 'pratica/pratica/{idPratica}/contocorrente',
        DATI_CONTO_CORRENTE: 'pratica/recuperaPraticaCc/', // recuperaPraticaCc/:idPratica,
        DEF_PRODOTTO: '/definizione', // pratica/:idPratica/definizione
        DATI_AGGIUNTIVI: '/datiaggiuntivi', // pratica/:idPratica/datiaggiuntivi,
        DATI_AML: '/datiAml', // pratica/:idPratica/datiAml,
        QUESTIONARI: '/questionari', // pratica/:idPratica/questionari,
        COMPLETA: '/completa', // pratica/:idPratica/completa,
        ANNULLA: '/annulla',
        RIFIUTA: '/rifiuta',
        PROSPETTOPERSONAFISICA: 'pratica/verifica/',
        VERIFICAPRESAINCARICO: '/verificaPresaInCarico',
        PRENDIINCARICO: '/prendiInCarico',
        RILASCIAPRATICA: '/rilasciaPratica',
        VERIFICA_CONTO_LIGHT: 'pratica/verificaContoLight'
      },
      ACCETTAZIONE: 'api/NaturalPerson/Accept',
      CPT: 'cpt/pratica/',
      QUESTIONARI: {
        NEXI: 'questionari/privacynexi/' // questionari/privacynexi/:idPratica
      },
      RICERCA: {
        CLIENTI: 'Customer/Search', // Da combinare con REST_CLIENTI_ROOT
        CONTICORRENTI: 'contocorrente/conticorrenti/',
        RAPPORTI_DELEGATI:'contocorrente/rapportiDelegati/'//:ndg
      },
      POST_VENDITA: {
        CREA: 'cartaPostVendita/pratica/',
        DETTAGLIO: 'cartaPostVendita/pratica/', // pratica/:ndg/:idPratica
        CARTA_NDG: 'cartaPostVendita/carte/',
        //        CONTI_NDG: 'cartaPostVendita/carta/elencoConti/',
        CONTI_NDG: 'contocorrente/conticorrenti/',
        FUNZIONI: 'cartaPostVendita/carta/funzioni/',
        ELENCO_BLOCCO: 'cartaPostVendita/carte/blocco',
        ELENCO_CONDIZIONI: 'cartaPostVendita/carte/condizioni',
        ELENCO_LIMITI: 'cartaPostVendita/carta/{codProdotto}/limiti',
        ANNULLA: 'cartaPostVendita/pratica/{id}/annulla',
        RECUPERA: 'cartaPostVendita/pratica/datiaggiuntivi/' // pratica/datiaggiutnivi/:idPratica
      },
      REQ_LOTT: {
        CREA_RICHIESTA: 'reqLott/crea/',
        RECUPERA_LISTA_PRODOTTI: 'reqLott/recuperaListaProdotti/',
        // RECUPERA_LISTA_PRODOTTI: 'http://localhost:3000/recuperaListaProdotti',
        // RECUPERA_INDIRIZZI_DEFAULT: '/CBL-FILIALE-WA-2.0/assets/mock/indirizzo-default.json'
        RECUPERA_INDIRIZZI_DEFAULT: 'reqLott/recuperaIndirizzoDefault',
        CERCA_LOTTI: 'reqLott/cerca/',
        STATI_LOTTI: 'reqLott/recuperaStatiLotto/'
      }
    },
    STATO_PRATICA: {
      IN_CORSO: 'INCORSO',
      CONSOLIDATA: 'CONSOLIDATA',
      PRESENTATA: 'PRESENTATA',
      DAREVISIONARE: 'DAREVISIONARE',
      ACCETTATA: 'ACCETTATA',
      ANNULLATA: 'ANNULLATA',
      RIFIUTATA: 'RIFIUTATA'
    },
    SPECIALIZZAZIONI: {
      LIGHT: 'PROPOSTACARTADEBITOINTERNAZIONALE',
      SMALLBUSINESS: 'PROPOSTACARTADEBITOINTERNAZIONALESTD',
      CONSUMER: 'PROPOSTACARTADEBITOINTCONSUMER',
      MAINTENANCE_CARTA_DEBITO: 'MAINTENANCE_CARTA_DEBITO'
    },
    FUNZIONI: {
      ATTIVA_BLOCCO: 'APLBLC',
      RIMUOVI_BLOCCO: 'RMZBLC',
      DUP_CARTA: 'DUPCRT',
      RIF_CARTA: 'RIFCRT',
      MOD_INTESTA: 'MODINT',
      MOD_CONDIZIONI: 'MODCND',
      MOD_LIMITI: 'MODLMT',
      MOD_CONTO: 'MODCNT',
      MOD_INDIRIZZO: 'MODIND'
    },
    CANALE: {
      PROMOTORE: 'BRIO_PROMOTORE',
      FILIALE: 'FILIALE',
      BANCACLOUD: 'BANCACLOUD'
    }
  });
})(window);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * @ngdoc overview
 * @name cbl.cartadebitoint.wa
 * @description Modulo funzionale dell'applicazione Carta di Debito Internazionale
 */
(function() {
  'use strict';
  angular.module('cbl.cartadebitoint.wa', [
    'ui.router',
    'ui.bootstrap',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.cellNav',
    'ui.grid.edit',
    'ui.grid.exporter',
    'ui.grid.grouping',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.rowEdit',
    'ui.grid.selection',
    'ui.grid.treeView',
    'cbl.cartadebitoint.wa.directives',
    'cbl.common',
    'ngSanitize'
  ]);
})();


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 *
 */

(function (window, undefined) {
  'use strict';
  var Route = function ($stateProvider, $urlRouterProvider) {
    var onEnter = [
      'CblMessageSrvc',
      function (messaggiSrvc) {
        messaggiSrvc.reset();
      }
    ];

    $stateProvider
      .state('cdint-proposta-carta-debito-int-pratica-n', {
        url: '/propostaCartaDebitoInternazionale/:idPratica/n/:ndg',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('cdint-proposta-carta-debito-int-prodotto', {
        url: '/propostaCartaDebitoInternazionale/:ndg/:idProdotto/:idTargetMarket',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('cdint-proposta-carta-debito-int-pratica', {
        url: '/propostaCartaDebitoInternazionale/:idPratica',
        template: '<cdint-proposta-carta-debito-int class="wrapper"></<cdint-proposta-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Carta Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      // postVendita OBI
      .state('post-vendita-debito-int-pratica', {
        url: '/postVenditaCartaDebitoInternazionale/:ndg',
        template: '<post-vendita-carta-debito-int class="wrapper"></<post-vendita-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('post-vendita-debito-int-pratica-id', {
        url: '/postVenditaCartaDebitoInternazionale/:ndg/:idPratica',
        template: '<post-vendita-carta-debito-int class="wrapper"></<post-vendita-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Debito Internazionale',
          parent: 'schedaCliente'
        }
      })
      .state('req-lott-carta-debito-int', {
        url: '/reqlottCartaDebitoInternazionale',
        template: '<req-lott-carta-debito-int class="wrapper"></<req-lott-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Richiesta Lotto Carte',
          parent: 'home'
        }
      })
      .state('inquiry-lott-carta-debito-int', {
        url: '/inquirylottCartaDebitoInternazionale',
        template: '<inquiry-lott-carta-debito-int class="wrapper"></<inquiry-lott-carta-debito-int>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Inquiry Richiesta Lotto Carte Instant Issuing',
          parent: 'home'
        }
      });
  };

  Route.$inject = ['$stateProvider', '$urlRouterProvider'];

  angular.module('cbl.cartadebitoint.wa').config(Route);
})(window);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 *
 */
(function (window, undefined) {
  'use strict';
  var Run = function (
    $http,
    $q,
    userSrvc,
    messaggiFctr,
    labelSrvc,
    loggerSrvc,
    CONSTANTS,
    ssocoreServices
  ) {
    var userSrvcDefer = $q.defer();
    var labelSrvcDefer = $q.defer();
    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
    labelSrvc.labelsPronte = labelSrvcDefer.promise;

    ssocoreServices.caricaContesto(
      function (response) {
        startAbilitazioniPromise();
        startLabelsPromise();
        startLoggerPromise();
      },
      function (reason) {}
    );

    var startAbilitazioniPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            userSrvcDefer.reject(response);
            return;
          }
          userSrvc.user = response.data.result.profile;
          userSrvc.abilitazioni = response.data.result.abilitazioni;
          if (window.CblBrioLoader) {
            CblBrioLoader.hideLoader();
          }
          userSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          userSrvcDefer.reject(reason);
        }
      );
    };

    var startLabelsPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            labelSrvcDefer.reject(response);
            return;
          }
          labelSrvc.labels = response.data.result;
          labelSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          labelSrvcDefer.reject(reason);
        }
      );
    };

    var startLoggerPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            return;
          }
          loggerSrvc.setupLogger(response.data.result);
          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
        }
      );
    };
  };

  Run.$inject = [
    '$http',
    '$q',
    'CdintUserSrvc',
    'CdintMessaggiFctr',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CDINT_CONSTANTS',
    'ssocoreServices',
  ];
  angular.module('cbl.cartadebitoint.wa').run(Run);
})(window);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAggiuntiviPf
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAggiuntiviPfCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Dati anagrafici originali (non filtrati o modificati a BE) legati alla pratica
     */
    this.datiAnagraficiOriginali = null;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.provinceSpedizione = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.provinceResidenza = [];

    /**
     * Elenco delle provincie selezionabili per l'ente rilascio
     */
    this.provinceEnteRilascio = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuniResidenza = [];

    /**
     * Elenco dei comuni selezionabili per l'ente rilascio
     */
    this.comuniEnteRilascio = [];

    /**
     * Elenco dei comuni selezionabili per l'indirizzo di spedizione
     */
    this.comuniSpedizione = [];

    /**
     * Elenco degli enti selezionabili
     */
    this.entiRilascio = [];

    /**
     * Elenco dei cap selezionabili per l'indirizzo di residenza
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili per l'indirizzo di residenza
     */
    this.localita = [];

    /**
     * Elenco dei cap selezionabili per l'indirizzo di spedizione
     */
    this.capSpedizione = [];

    /**
     * Elenco delle località selezionabili per l'indirizzo di spedizione
     */
    this.localitaSpedizione = [];

    /**
     * Flag che indica se l'indirizzo di spedizione è uguale a quello di residenza
     */
    this.spedizioneUgualeResidenza = true;

    /**
     * Flag che indica se il numero civico è editabile perchè non si è riusciti a recuperarlo dall'indirizzo
     */
    this.indirizzoEditabile = true;

    /**
     * Flag che indica se il paese spedizione è editabile
     */
    this.paeseSpedizioneReadOnly = true;

    /**
     * Flag che indica che l'anagrafica su cui si sta portando avanti la pratica
     * è incompleta quindi prima di poter proseguire bisogna aggiornarla.
     */
    this.anagraficaIncompleta = false;

    /**
     * Indirizzo prevalorizzazione
     */
    this.indirizzoPrevalorizzazione = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    this.riportaDatiResidenzaInSpedizione = function () {
      if (
        !self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf ||
        !self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione
      ) {
        return;
      }

      self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.via =
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.via;
      self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.numero =
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.numero;
    };

    /**
     * Funzione per sovrascrivere il comportamento
     * della chiamata sovrascrivendo l'indirizzo di spedizione,
     * viene richiamato quando si effettua il salvataggio dello step
     * o l'avanzamento di step: solo nel caso di 2 small business.
     */
    this.propostaCartaDebitoIntSrvc.copiaIndirizzoResidenzaInSpedizione = function () {
      // funzione sovrascritta da controller.
      if (self.spedizioneUgualeResidenza === true) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione = null;
        self.impostaSpedizioneUgualeAResidenza();
        //self.impostaSpedizioneDefault();
      }
    };

    this.impostaSpedizioneDefault = function () {
      // L'indirizzo da utilizzare per la prevalorizzazione è quello del domicilio se presente, altrimenti quello di residenza
      self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
        ? self.datiAnagrafici.indirizzoCorrispondenza
        : self.datiAnagrafici.indirizzoPrincipale;

      self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione = {
        via: self.indirizzoPrevalorizzazione.via,
        numero: null,
        provincia: self.indirizzoPrevalorizzazione.provincia,
        comune: {
          valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
        },
        cap: self.indirizzoPrevalorizzazione.cap,
        nazione: self.indirizzoPrevalorizzazione.nazione,
        localita: self.indirizzoPrevalorizzazione.localita
      };

      // provo a recuperare l'indirizzo ed il civico (se riesco)
      try {
        var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(self.indirizzoPrevalorizzazione.via);
        if (datiIndirizzoCivico) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via = self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero = datiIndirizzoCivico.civico;
        }
      } catch (error) {}
    };

    /**
     * Recupera i dati di residenza e li imposta nell'indirizzo di spedizione
     */
    this.impostaSpedizioneUgualeAResidenza = function () {
      if (!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione = {
          via: self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.via,
          numero: self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.numero,
          provincia: self.datiAnagrafici.indirizzoPrincipale.provincia,
          comune: {
            valore: self.datiAnagrafici.indirizzoPrincipale.comune
              ? self.datiAnagrafici.indirizzoPrincipale.comune.codice
              : null
          },
          cap: self.datiAnagrafici.indirizzoPrincipale.cap,
          nazione: self.datiAnagrafici.indirizzoPrincipale.nazione,
          localita: self.datiAnagrafici.indirizzoPrincipale.localita
        };
        // fix CDICDDI-171 (indirizzo nazione spedizione == italia --> Forzato)
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.nazione =
          CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
      }
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      if (!(self.datiAnagrafici && self.datiAnagrafici.indirizzoPrincipale) || self.anagraficaIncompleta) {
        return false;
      }

      var indirizzoPrincipaleValido =
        !!self.datiAnagrafici.indirizzoPrincipale.via &&
        !!self.datiAnagrafici.indirizzoPrincipale.provincia &&
        !!self.datiAnagrafici.indirizzoPrincipale.comune &&
        !!self.datiAnagrafici.indirizzoPrincipale.cap &&
        !!self.datiAnagrafici.indirizzoPrincipale.nazione &&
        !!self.datiAnagrafici.indirizzoPrincipale.localita;

      var indirizzoSpedizioneValido =
        // Se spedizione diversa da residenza controllo l'indirizzo spedizione
        (!self.spedizioneUgualeResidenza &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.via &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.numero &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.provincia &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.nazione &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita) ||
        // Se spedizione uguale a residenza controllo l'indirizzo residenza
        (self.spedizioneUgualeResidenza &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.via &&
          !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.numero &&
          !!self.datiAnagrafici.indirizzoPrincipale.provincia &&
          !!self.datiAnagrafici.indirizzoPrincipale.comune &&
          !!self.datiAnagrafici.indirizzoPrincipale.cap &&
          !!self.datiAnagrafici.indirizzoPrincipale.nazione &&
          !!self.datiAnagrafici.indirizzoPrincipale.localita);

      var docIdentitaValido =
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.id &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio.codice &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.codice;

      return indirizzoPrincipaleValido && indirizzoSpedizioneValido && docIdentitaValido;
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori, isDocumentoIdentita) {
      var provincia = '';
      if (!isDocumentoIdentita) {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.provincia;
      } else {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.codice;
      }

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione) {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune.valore = null;
        }

        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        if (!self.isDocumentoIdentita) {
          self.comuniSpedizione = [];
        } else {
          self.comuniEnteRilascio = [];
        }
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        if (!isDocumentoIdentita) {
          self.comuniSpedizione = domain;
        } else {
          self.comuniEnteRilascio = domain;
        }
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (flagIndirizzoSpedizione, pulisciValori) {
      self.spinner.showSpinner++;
      var comune = flagIndirizzoSpedizione
        ? self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune.valore
        : self.datiAnagrafici.indirizzoPrincipale.comune.codice;

      if (
        flagIndirizzoSpedizione &&
        pulisciValori &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione
      ) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          if (flagIndirizzoSpedizione === true) {
            self.capSpedizione = domain;
            if (self.capSpedizione.length == 1) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap = self.capSpedizione[0].codice;
              self.recuperaLocalita(true, true);
            }
          } else {
            self.cap = domain;
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (flagIndirizzoSpedizione, pulisciValori) {
      self.spinner.showSpinner++;

      var cap = flagIndirizzoSpedizione
        ? self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap
        : self.datiAnagrafici.indirizzoPrincipale.cap;

      var comune = flagIndirizzoSpedizione
        ? self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.citta
        : self.datiAnagrafici.indirizzoPrincipale.citta;

      if (
        flagIndirizzoSpedizione &&
        pulisciValori &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione
      ) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          if (flagIndirizzoSpedizione) {
            self.localitaSpedizione = domain;
            if (!self.localitaSpedizione.length) {
              self.localitaSpedizione.push({
                codice: comune,
                descrizione: comune
              });
            }
          } else {
            self.localita = domain;
            if (!self.localita.length) {
              self.localita.push({ codice: comune, descrizione: comune });
            }
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          self.provinceResidenza = responses[1];
          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.provinceSpedizione = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice === '086') {
            self.provinceEnteRilascio = responses[1];
            self.provinceEnteRilascio = self.provinceEnteRilascio.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.provinceEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
            self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio = {
              codice: '**',
              descrizione: 'STATO ESTERO'
            };
            // Devo forzare la chiamata di onProvinciaChange perché non "sente" la valorizzazione
            self.onProvinciaChange();
          }
          self.entiRilascio = responses[2].data ? responses[2].data.result.elenco : [];
          // Se l'ente di rilascio è stato prevalorizzato allora devo aggiornarlo attraverso l'onChange
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.enteRilascio) {
            self.onEnteChange();
          }

          self.recuperaComuni(false, false);
          // Se è presente il valore provinciaRilascio, viene prevalorizzato nella select
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.codice !== '**'
          ) {
            self.recuperaComuni(false, true);
          }

          if (
            self.datiAnagrafici.indirizzoPrincipale.cap ||
            (self.datiAnagrafici.indirizzoPrincipale.comune && self.datiAnagrafici.indirizzoPrincipale.comune.codice)
          ) {
            self.recuperaCAP(false);
          }

          if (self.datiAnagrafici.indirizzoPrincipale.localita || self.datiAnagrafici.indirizzoPrincipale.cap) {
            self.recuperaLocalita(false);
          }

          // Se ho un indirizzo di spedizione, richiamo anche i relativi domini
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione) {
            if (
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap ||
              (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune &&
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune.valore)
            ) {
              self.recuperaCAP(true);
            }

            if (
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita ||
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap
            ) {
              self.recuperaLocalita(true);
            }
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione chiamata al change di provincia di documento identità. Setta correttamente la provincia
     * selezionata nel service e chiama recupera comuni
     */
    this.onProvinciaChange = function () {
      for (var i = 0; i < self.provinceEnteRilascio.length; i++) {
        if (
          self.provinceEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.descrizione =
            self.provinceEnteRilascio[i].descrizione;
          break;
        }
      }
      self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio = null;
      // Seleziona di provincia come stato estero
      if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.provinciaRilascio.codice === '**') {
        self.comuniEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio = {
          codice: '**',
          descrizione: 'STATO ESTERO'
        };
      } else {
        self.recuperaComuni(false, true);
      }
    };

    /**
     * Funzione chiamata al change di comune di documento identità. Setta correttamente il comune
     * selezionato nel service
     */
    this.onComuneChange = function () {
      for (var i = 0; i < self.comuniEnteRilascio.length; i++) {
        if (
          self.comuniEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.comuneRilascio.descrizione =
            self.comuniEnteRilascio[i].descrizione;
          break;
        }
      }
    };

    /**
     * Funzione chiamata al change di ente di documento identità. Setta correttamente l'ente
     * selezionato nel service
     */
    this.onEnteChange = function () {
      if (!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.enteRilascio) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.id = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.tipoDocumento = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.codiceEnteNexi = null;
        return;
      }
      for (var i = 0; i < self.entiRilascio.length; i++) {
        if (
          self.entiRilascio[i].enteRilascio ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.enteRilascio
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.id =
            self.entiRilascio[i].id;
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.tipoDocumento =
            self.entiRilascio[i].tipoDocumento;
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.codiceEnteNexi =
            self.entiRilascio[i].codiceEnteNexi;
          break;
        }
      }
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDatiAggiuntivi(self.idPratica),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagrafica(self.idPratica, true)
      ])
        .then(function (responses) {
          // Dati già salvati
          if (responses[0] && responses[0].data && !self.messaggiFctr.processaResponse(responses[0])) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf = responses[0].data.result;
            self.propostaCartaDebitoIntSrvc.currentTipoCarta =
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.tipoCarta;
          }

          // Anagrafica
          if (responses[1] && responses[1].data) {
            // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
            // dei dati mancanti nell'anagrafica. QUindi imposto il flag è disabilito il bottone
            // per proseguire
            self.anagraficaIncompleta = self.messaggiFctr.processaResponse(responses[1]);

            self.datiAnagrafici =
              responses[1].data.result && responses[1].data.result.anagrafica
                ? responses[1].data.result.anagrafica
                : {
                    contatti: {},
                    documentoIdentificativo: {},
                    indirizzoPrincipale: {},
                    indirizzoSpedizione: {}
                  };

            self.datiAnagraficiOriginali = responses[1].data.result.anagraficaOriginale || {
              contatti: {},
              documentoIdentificativo: {},
              indirizzoPrincipale: {},
              indirizzoSpedizione: {},
              enteRilascio: {}
            };

            // Valorizzazione comune di residenza
            if (self.datiAnagrafici.indirizzoPrincipale.comune) {
              self.comuniResidenza = [
                {
                  codice: self.datiAnagrafici.indirizzoPrincipale.comune.codice,
                  descrizione: self.datiAnagrafici.indirizzoPrincipale.comune.descrizione
                }
              ];
            }

            // Prevalorizzazione ente rilascio
            // Se non è presente nei dati aggiuntivi lo prendo da anagrafica
            if (
              !(
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita &&
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio &&
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.enteRilascio
              )
            ) {
              if (self.datiAnagrafici.documentoIdentificativo) {
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio = {};
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.documentoIdentita.datiEnteRilascio.enteRilascio =
                  self.datiAnagrafici.documentoIdentificativo.enteRilascioDocumento;
                // RecuperaDomini viene chiamato in sequenza dopo questa chiamata, quindi la valorizzazione
                // onEnteChange di enteRilascio viene lasciata a recuperaDomini
              }
            }

            // Formattazione date
            if (
              self.datiAnagrafici.documentoIdentificativo &&
              self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
            ) {
              self.datiAnagrafici.documentoIdentificativo.rilascioDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
                );
            }
            if (
              self.datiAnagrafici.documentoIdentificativo &&
              self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
            ) {
              self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
                );
            }

            // Se non ho dati aggiuntivi, creo il payload con la sola id pratica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf = {
                idPratica: self.idPratica,
                indirizzoSpedizione: null,
                tae: null
              };
            }

            // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione) {
              self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
                ? self.datiAnagrafici.indirizzoCorrispondenza
                : self.datiAnagrafici.indirizzoPrincipale;

              self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione = {
                via: self.indirizzoPrevalorizzazione.via,
                numero: null,
                provincia: self.indirizzoPrevalorizzazione.provincia,
                comune: {
                  valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
                },
                cap: self.indirizzoPrevalorizzazione.cap,
                nazione: self.indirizzoPrevalorizzazione.nazione,
                localita: self.indirizzoPrevalorizzazione.localita
              };

              if (self.datiAnagrafici.indirizzoPrincipale.nazione != '086') {
                self.spedizioneUgualeResidenza = false;
                self.datiAnagrafici.indirizzoPrincipale.comune.codice = self.datiAnagrafici.indirizzoPrincipale.comune
                  .codice
                  ? self.datiAnagrafici.indirizzoPrincipale.comune.codice
                  : '';
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.nazione = '086';
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.via = '';
                self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.numero = '';
              } else {
                self.spedizioneUgualeResidenza = true;
              }

              // provo a recuperare l'indirizzo ed il civico della spedizione (indirizzoCorrispondenza dell'anagrafica)
              try {
                var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                  self.indirizzoPrevalorizzazione.via
                );
                if (datiIndirizzoCivico && self.datiAnagrafici.indirizzoPrincipale.nazione === '086') {
                  self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.via =
                	  self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
                  self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.numero =
                    datiIndirizzoCivico.civico;
                }
              } catch (error) {}

              // Imposto via e numero civico dell'indirizzo di residenza (indirizzoPrincipale dell'anagrafica)
              try {
                if (self.datiAnagrafici.indirizzoPrincipale.nazione === '086') {
                  var datiIndirizzoCivicoResidenza = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                    self.datiAnagrafici.indirizzoPrincipale.via
                  );

                  if (datiIndirizzoCivicoResidenza) {
                    // aggiorno anche i dati della residenza
                    self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.via =
                    	self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivicoResidenza.indirizzo);
                    self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.numero =
                      datiIndirizzoCivicoResidenza.civico;
                  }
                } else {
                  self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoResidenza.via =
                    self.datiAnagrafici.indirizzoPrincipale.via;
                }
              } catch (error) {}
            }
            // a questo punto se indirizzo spedizione non uguale a residenza imposto
            // il flag a false.
            // FIX CDICDDI-212
            else {
              // se ho fatto un salvataggio di pratica ho che l'indirizzo di spedizione è valorizzato
              // quindi entro qui dento e devo verifiare campo campo che residenza != da spedizione per settare
              // correttamente il valore del flag.
              self.spedizioneUgualeResidenza = self.confrontaIndirizzoResidenzaSpedizione();
            }
            self.recuperaDomini();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.checkNazione = function () {
      //se la nazione non è italia lo forzo a disabled ritornando true
      if (self.datiAnagrafici.indirizzoPrincipale.nazione != '086') {
        return true;
      } else {
        return false;
      }
    };

    this.confrontaIndirizzoResidenzaSpedizione = function () {
      return (
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.cap ===
          self.datiAnagrafici.indirizzoPrincipale.cap &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.comune.valore ===
          self.datiAnagrafici.indirizzoPrincipale.comune.codice &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.localita ===
          self.datiAnagrafici.indirizzoPrincipale.localita &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.nazione ===
          self.datiAnagrafici.indirizzoPrincipale.nazione &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.via +
          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.numero ===
          self.datiAnagrafici.indirizzoPrincipale.via &&
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf.indirizzoSpedizione.provincia ===
          self.datiAnagrafici.indirizzoPrincipale.provincia
      );
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;
        self.propostaCartaDebitoIntSrvc.isRedirecting = false;
        self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;

        self.recuperaAnagrafica();
      });
    };

    self.init();
  };

  CdintDatiAggiuntiviPfCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPf/cdintDatiAggiuntiviPf.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAggiuntiviPfComponent = {
    controller: CdintDatiAggiuntiviPfCtrl,
    controllerAs: 'cdintDatiAggiuntiviPfCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAggiuntiviPf', CdintDatiAggiuntiviPfComponent);
})();


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAggiuntiviPg
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAggiuntiviPgCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Flag che indica che l'anagrafica su cui si sta portando avanti la pratica
     * è incompleta quindi prima di poter proseguire bisogna aggiornarla.
     */
    this.anagraficaIncompleta = false;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        !!self.datiAnagrafici &&
        !!self.datiAnagrafici.indirizzoPrincipale &&
        !!self.datiAnagrafici.indirizzoPrincipale.via &&
        !!self.datiAnagrafici.indirizzoPrincipale.provincia &&
        !!self.datiAnagrafici.indirizzoPrincipale.comune &&
        !!self.datiAnagrafici.indirizzoPrincipale.cap &&
        !!self.datiAnagrafici.indirizzoPrincipale.nazione &&
        !!self.datiAnagrafici.indirizzoPrincipale.localita &&
        !self.anagraficaIncompleta
      );
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function () {
      self.spinner.showSpinner++;
      var provincia = self.datiAnagrafici.indirizzoPrincipale.provincia;

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      self.spinner.showSpinner++;
      var comune = self.datiAnagrafici.indirizzoPrincipale.comune.codice;

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function () {
      self.spinner.showSpinner++;
      var cap = self.datiAnagrafici.indirizzoPrincipale.cap;
      var comune = self.datiAnagrafici.indirizzoPrincipale.citta;

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')])
        .then(function (responses) {
          self.paesi = responses[0];
          self.province = responses[1];

          self.recuperaComuni();

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.datiAnagrafici.indirizzoPrincipale &&
            (self.datiAnagrafici.indirizzoPrincipale.cap ||
              (self.datiAnagrafici.indirizzoPrincipale.comune && self.datiAnagrafici.indirizzoPrincipale.comune.codice))
          ) {
            self.recuperaCAP();
          }

          if (
            self.datiAnagrafici.indirizzoPrincipale &&
            (self.datiAnagrafici.indirizzoPrincipale.localita || self.datiAnagrafici.indirizzoPrincipale.cap)
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      self.spinner.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseRecuperaAnagrafica(self.idPratica)
        .then(function (response) {
          if (!response) {
            return;
          }

          // Processo prima la risposta perchè potrebbero esserci dei dati mancanti
          // relativi all'anagrafica e il servizio rende un messaggio per questo.
          self.anagraficaIncompleta = self.messaggiFctr.processaResponse(response);

          // Inizializzo i dati aggiuntivi a vuoti, per dare comunque un valore
          // e avviare la chiamata di salva/prosegui
          self.datiAnagrafici = response.data.result.anagrafica || {
            indirizzoPrincipale: {},
            contatti: {}
          };

          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPg = {
            idPratica: self.idPratica
          };

          self.recuperaDomini();
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;
        self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;

        self.recuperaAnagrafica();
      });
    };

    self.init();
  };

  CdintDatiAggiuntiviPgCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPg/cdintDatiAggiuntiviPg.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAggiuntiviPgComponent = {
    controller: CdintDatiAggiuntiviPgCtrl,
    controllerAs: 'cdintDatiAggiuntiviPgCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAggiuntiviPg', CdintDatiAggiuntiviPgComponent);
})();


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAggiuntivi
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAggiuntiviCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Dati anagrafici originali (non filtrati o modificati a BE) legati alla pratica
     */
    this.datiAnagraficiOriginali = null;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Elenco dei valori selezionabili per il campo TAE
     */
    this.tae = [];

    /**
     * Flag che indica se il paese spedizione è editabile
     */
    this.paeseSpedizioneReadOnly = true;

    /**
     * Elenco dei comuni selezionabili per l'ente rilascio
     */
    this.comuniEnteRilascio = [];

    /**
     * Elenco delle province selezionabili per l'ente rilascio
     */
    this.provinceEnteRilascio = [];

    /**
     * Elenco degli enti selezionabili
     */
    this.entiRilascio = [];

    /**
     * Ente rilascio selezionato
     */
    this.enteRilascio = null;

    /**
     * Indirizzo prevalorizzazione
     */
    this.indirizzoPrevalorizzazione = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        !self.anagraficaIncompleta &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tae &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
        !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
      );
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori, isDocumentoIdentita) {
      var provincia = '';
      if (!isDocumentoIdentita) {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;
      } else {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice;
      }

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        if (!self.isDocumentoIdentita) {
          self.comuni = [];
        } else {
          self.comuniEnteRilascio = [];
        }
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        if (!isDocumentoIdentita) {
          self.comuni = domain;
        } else {
          self.comuniEnteRilascio = domain;
        }
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    function recuperaProvinceImpl() {
      return self.domainSrvc.promiseDomain('PROVINCIA').finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * @ngdoc method
     * @name recuperaProvinciaEnteRilascio
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le province per l'ente rilascio
     */
    this.recuperaProvinciaEnteRilascio = function () {
      self.spinner.showSpinner++;

      recuperaProvinceImpl().then(function (domain) {
        self.provinceEnteRilascio = domain;
      });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice === '086') {
            self.provinceEnteRilascio = responses[1];
            self.provinceEnteRilascio = self.provinceEnteRilascio.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.provinceEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice = '**';
            // Devo forzare la chiamata di onProvinciaChange perché non "sente" la valorizzazione
            self.onProvinciaChange();
          }
          self.tae = responses[2];

          // Riordina tae in ordine alfabetico
          self.tae.sort(function (a, b) {
            if (a.descrizione > b.descrizione) {
              return 1;
            } else if (a.descrizione === b.descrizione) {
              return 0;
            } else {
              return -1;
            }
          });

          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];
          // Se l'ente di rilascio è stato prevalorizzato allora devo aggiornarlo attraverso l'onChange
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) {
            self.onEnteChange();
          }
          self.recuperaComuni(false, false);

          // Se è presente il valore provinciaRilascio, viene prevalorizzato nella select
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice !== '**'
          ) {
            self.recuperaComuni(false, true);
          }

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // fix CDICDDI-171 (indirizzo nazione spedizione == italia --> Forzato)
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * Funzione chiamata al change di provincia di documento identità. Setta correttamente la provincia
     * selezionata nel service e chiama recupera comuni
     */
    this.onProvinciaChange = function () {
      for (var i = 0; i < self.provinceEnteRilascio.length; i++) {
        if (
          self.provinceEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.descrizione =
            self.provinceEnteRilascio[i].descrizione;
          break;
        }
      }
      self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice = null;
      // Seleziona di provincia come stato estero
      if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice === '**') {
        self.comuniEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice = '**';
      } else {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice) {
          self.recuperaComuni(false, true);
        } else {
          self.comuniEnteRilascio = [];
        }
      }
    };

    /**
     * Funzione chiamata al change di comune di documento identità. Setta correttamente il comune
     * selezionato nel service
     */
    this.onComuneChange = function () {
      for (var i = 0; i < self.comuniEnteRilascio.length; i++) {
        if (
          self.comuniEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.descrizione =
            self.comuniEnteRilascio[i].descrizione;
          break;
        }
      }
    };

    /**
     * Funzione chiamata al change di ente di documento identità. Setta correttamente l'ente
     * selezionato nel service
     */
    this.onEnteChange = function () {
      if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi = null;
        return;
      }
      for (var i = 0; i < self.entiRilascio.length; i++) {
        if (
          self.entiRilascio[i].enteRilascio ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id =
            self.entiRilascio[i].id;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento =
            self.entiRilascio[i].tipoDocumento;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi =
            self.entiRilascio[i].codiceEnteNexi;
          break;
        }
      }
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      self.spinner.showSpinner++;
      $q.all([
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDatiAggiuntivi(self.idPratica),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagrafica(self.idPratica)
      ])
        .then(function (responses) {
          // Dati già salvati
          if (responses[0] && responses[0].data && !self.messaggiFctr.processaResponse(responses[0])) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = responses[0].data.result;

            self.propostaCartaDebitoIntSrvc.currentTipoCarta = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta;
          }

          // Anagrafica
          if (responses[1] && responses[1].data) {
            // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
            // dei dati mancanti nell'anagrafica. Quindi imposto il flag è disabilito il bottone
            // per proseguire
            self.anagraficaIncompleta = self.messaggiFctr.processaResponse(responses[1]);
            self.datiAnagrafici = responses[1].data.result.anagrafica || {
              contatti: {},
              documentoIdentificativo: {},
              indirizzoPrincipale: {},
              indirizzoSpedizione: {},
              enteRilascio: {}
            };
            self.datiAnagraficiOriginali = responses[1].data.result.anagraficaOriginale || {
              contatti: {},
              documentoIdentificativo: {},
              indirizzoPrincipale: {},
              indirizzoSpedizione: {},
              enteRilascio: {}
            };

            // Prevalorizzazione ente rilascio
            // Se non è presente nei dati aggiuntivi lo prendo da anagrafica
            if (
              !(
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
              )
            ) {
              if (self.datiAnagrafici.documentoIdentificativo) {
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio = {};
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio =
                  self.datiAnagrafici.documentoIdentificativo.enteRilascioDocumento;
                // RecuperaDomini viene chiamato in sequenza dopo questa chiamata, quindi la valorizzazione
                // onEnteChange di enteRilascio viene lasciata a recuperaDomini
              }
            }

            // Formattazione date
            if (self.datiAnagrafici.documentoIdentificativo.rilascioDocumento) {
              self.datiAnagrafici.documentoIdentificativo.rilascioDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
                );
            }
            if (self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento) {
              self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento =
                self.propostaCartaDebitoIntSrvc.millisToDate(
                  self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
                );
            }

            // Se non ho dati aggiuntivi, creo il payload con la sola id pratica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {
                idPratica: self.idPratica,
                indirizzoSpedizione: null,
                tae: null
              };
            }

            // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
              // L'indirizzo da utilizzare per la prevalorizzazione è quello del domicilio se presente, altrimenti quello di residenza
              self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
                ? self.datiAnagrafici.indirizzoCorrispondenza
                : self.datiAnagrafici.indirizzoPrincipale;

              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione = {
                via: self.indirizzoPrevalorizzazione.via,
                numero: null,
                provincia: self.indirizzoPrevalorizzazione.provincia,
                comune: {
                  valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
                },
                cap: self.indirizzoPrevalorizzazione.cap,
                nazione: self.indirizzoPrevalorizzazione.nazione,
                localita: self.indirizzoPrevalorizzazione.localita
              };

              // provo a recuperare l'indirizzo ed il civico (se riesco)
              try {
                var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                  self.indirizzoPrevalorizzazione.via
                );
                if (datiIndirizzoCivico) {
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via =
                	  self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero =
                    datiIndirizzoCivico.civico;
                }
              } catch (error) {}
            }
          }

          self.recuperaDomini();
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;
        self.propostaCartaDebitoIntSrvc.isRedirecting = false;
        self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;
        self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf = null;
        self.recuperaAnagrafica();
      });
    };

    self.init();
  };

  CdintDatiAggiuntiviCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDatiAggiuntivi/cdintDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAggiuntiviComponent = {
    controller: CdintDatiAggiuntiviCtrl,
    controllerAs: 'cdintDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAggiuntivi', CdintDatiAggiuntiviComponent);
})();


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAml
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAmlCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    questionarioKycService,
    $uibModal,
    $element
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    this.questionarioKycService = questionarioKycService;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID del conto corrente
     */
    this.idConto = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    // PER IL MOMENTO NON UTILIZZATO
    //
    // Il pulsante Prosegui è sempre abilitato (https://youtrack.cabel.net/issue/CDICDDI-189)
    // /**
    //  * Verifica se i dati inseriti nel form sono validi
    //  */
    // this.formValido = function () {
    //   // recupero tutti gli elementi select enabled selezionati.
    //   var kycRapporto = angular.element('#kyc-rapporto :enabled option:selected', $element);

    //   // se non ho ancora caricato il form passo.
    //   if (kycRapporto && kycRapporto.length == 0) return false;
    //   var okForm = 0; // tutto ok

    //   // scorro tutto e riquadro i dati obbligatori
    //   // + check per disabilita form.
    //   kycRapporto.each(function (index) {
    //     var value = $(this).text().trim();
    //     if (!value) {
    //       $(this).focus();
    //       $(this).parent().addClass('border border-danger');
    //       okForm += 1;
    //     } else $(this).parent().removeClass('border border-danger');
    //   });

    //   return okForm === 0;
    // };

    this.propostaCartaDebitoIntSrvc.proseguiAml = function () {
      return self.questionarioKycService.stepForward();
    };

    this.propostaCartaDebitoIntSrvc.salvaAml = function () {
      return self.questionarioKycService.saveCurrentFase();
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.propostaCartaDebitoIntSrvc.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .promiseRecuperaDatiConto(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
          .then(function (response) {
            if (response.data && response.data.result) {
              self.idConto = response.data.result.idPratica;
            }
          })
          .finally(function () {
            if (self.propostaCartaDebitoIntSrvc.spinner.showSpinner > 0) {
              self.propostaCartaDebitoIntSrvc.spinner.showSpinner--;
            }
          });
      });
    };

    self.init();
  };

  CdintDatiAmlCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    'QuestionarioKycService',
    '$uibModal',
    '$element'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintDatiAml/cdintDatiAml.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAmlComponent = {
    controller: CdintDatiAmlCtrl,
    controllerAs: 'cdintDatiAmlCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAml', CdintDatiAmlComponent);
})();


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDefinizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDefinizioneCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    this.domainSrvc = domainSrvc;

    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Riferimento allo spinner di ricerca cliente
     */
    this.spinnerCliente = {
      showSpinner: 0
    };

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Descrizione del prodotto recuperata dalla pratica
     */
    this.tipoProdotto = null;

    /**
     * Descrizione del prodotto recuperata dalla rotta
     */
    this.idProdotto = null;

    /**
     * Specializzazione della pratica
     */
    this.specializzazione = null;

    /**
     * Definizione della griglia dei conti corrente
     */
    this.contiGridOptions = {};

    /**
     * Altezza della griglia dei conti corrente
     */
    this.altezzaTabellaConti = 0;

    /**
     * Altezza di una riga della griglia dei conti corrente
     */
    this.altezzaRigaConto = 30;

    /**
     * Conti corrente disponibili
     */
    this.contiCorrente = null;
    this.contiCorrenteProvvisorio = null;
    this.rapportiDelegati = null;
    /**
     * NDG usato come filtro per la ricerca utilizzatore
     */
    this.ricercaNdg = null;

    /**
     * Intestazione usata come filtro per la ricerca utilizzatore
     */
    this.ricercaIntestazione = null;

    /**
     * Definizione della griglia gli utilizzatori
     */
    this.utilizzatoriGridOptions = {};

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei comuni selezionabili per l'ente rilascio
     */
    this.comuniEnteRilascio = [];

    /**
     * Elenco delle province selezionabili
     */
    this.province = [];

    /**
     * Elenco delle province selezionabili per l'ente rilascio
     */
    this.provinceEnteRilascio = [];

    /**
     * Elenco degli enti selezionabili
     */
    this.entiRilascio = [];

    /**
     * Altezza della griglia degli utilizzatori
     */
    this.altezzaTabellaUtilizzatori = 0;

    /**
     * Altezza di una riga della griglia degli utilizzatori
     */
    this.altezzaRigaUtilizzatori = 30;

    /**
     * Elenco utilizzatori recuperato da ricerca
     */
    this.utilizzatori = null;

    /**
     * Flag che indica se il paese spedizione è editabile
     */
    this.paeseSpedizioneReadOnly = true;
    
    /**
     * Lista di ndg per recuperare i CC
     */
    this.listaNdg

    this.templateSpedizioneUrl =
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.html';

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di visualizzazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaVisibile = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return true;
        default:
          return false;
      }
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Implementazione nel service della funzione completaVisibile
     */
    this.propostaCartaDebitoIntSrvc.completaVisibile = function () {
      return false;
    };
    /**
     * Implementazione nel service della funzione rifiutaVisibile
     */
    this.propostaCartaDebitoIntSrvc.rifiutaVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return (
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
          return (
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
          );
        default:
          return false;
      }
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      switch (self.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
          return (
            !self.anagraficaIncompleta &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta &&
            // se instant issue --> obbligatorio codice busta.
            (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I1' ||
              (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I2' &&
                self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta))
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
          return (
            !self.anagraficaIncompleta &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban &&
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta &&
            // se instant issue --> obbligatorio codice busta.
            (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I1' ||
              (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta === 'I2' &&
                self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta))
          );
        case self.CONSTANTS.SPECIALIZZAZIONI.LIGHT:
          return (
            !self.anagraficaIncompleta &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tae &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio &&
            !!self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio
          );
        default:
          return true;
      }
    };

    /**
     * Funzione asseganta al cambio di selezione nella tabella utilizzatori
     * Assegna o rimuove l'utilizzatore
     */
    this.selezionaUtilizzatore = function (utilizzatore) {
      if (self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore !== utilizzatore.entity.ndg) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore = utilizzatore.entity.ndg;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore = null;
      }
    };

    /**
     * Funzione che esegue la ricerca degli utilizzatori in base ai parametri indicati
     */
    this.ricercaUtilizzatori = function () {
      self.messaggiFctr.resetMessages();
      self.spinnerCliente.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseRicercaCliente(self.ricercaNdg, self.ricercaIntestazione)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            // Filtro gli utilizzatori per natura giuridica PRV e IND
            self.utilizzatori = response.data.filter(function (item) {
              return item.naturaGiuridica === 'PRV' || item.naturaGiuridica === 'IND';
            });

            self.utilizzatoriGridOptions = {
              enableSorting: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              enableColumnMenus: false,
              enableGrouping: false,
              enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              treeRowHeaderAlwaysVisible: false,
              useExternalPagination: false,
              paginationPageSizes: [10, 25, 50],
              paginationPageSize: 10,
              paginationCurrentPage: 1,
              enableRowSelection: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              multiSelect: false,
              enableRowHeaderSelection: false,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
              columnDefs: [
                {
                  name: $scope.msg('label.definizione.utilizzatore.ndg'),
                  field: 'ndg',
                  minWidth: 100,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'ndg'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.intestazione'),
                  field: 'intestazione',
                  minWidth: 200,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'intestazione'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.codicefiscale'),
                  field: 'codiceFiscale',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'codiceFiscale'
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.prospetto'),
                  field: 'prospetto',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  cellTemplate:
                    "<div class=\"ui-grid-cell-contents\">{{row.entity.prospetto === true ? 'Prospetto' : 'Cliente'}}</div>"
                },
                {
                  name: $scope.msg('label.definizione.utilizzatore.stato'),
                  field: 'statoPratica',
                  minWidth: 130,
                  enableFiltering: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
                  name: 'stato'
                }
              ],
              data: self.utilizzatori,
              onRegisterApi: function (gridApi) {
                gridApi.grid.modifyRows(self.utilizzatoriGridOptions.data);

                // Se era già stato salvato l'utilizzatore lo recupero e lo seleziono
                if (
                  self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
                  self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
                ) {
                  angular.forEach(self.utilizzatori, function (utilizzatore, index) {
                    if (utilizzatore.ndg === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore) {
                      gridApi.selection.selectRow(self.utilizzatori[index]);
                    }
                  });
                }

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaUtilizzatore(row);
                });
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinnerCliente.showSpinner--;
        });
    };

    /**
     * Funzione assegnata alla selezione di una riga di conto corrente
     */
    this.selezionaConto = function (conto) {
      if (
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto !== conto.entity.numeroRapporto &&
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban !== conto.entity.iban
      ) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto = conto.entity.numeroRapporto;
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban = conto.entity.iban;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto = null;
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban = null;
      }
      if (
        conto.entity.idPraticaProposta &&
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto !== conto.entity.idPraticaProposta
      ) {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto = conto.entity.idPraticaProposta;
      } else {
        self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.idPraticaConto = null;
      }
    };

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.caricaContiCorrente = function (ndgList) {
      var promiseList = [];
      for (var i = 0; i < ndgList.length; i++) {
        promiseList.push(self.propostaCartaDebitoIntSrvc.promiseRecuperaContiCorrente(ndgList[i]));
      }
      self.spinner.showSpinner++;
      $q.all(promiseList)
        .then(
          function (responses) {
            self.contiCorrenteProvvisorio = [];
            for (var responsesIndex = 0; responsesIndex < responses.length; responsesIndex++) {
              if (responses[responsesIndex].data && responses[responsesIndex].data.result) {
                for (var dataIndex = 0; dataIndex < responses[responsesIndex].data.result.length; dataIndex++) {
                  self.contiCorrenteProvvisorio.push(responses[responsesIndex].data.result[dataIndex]);
                }
              }
            }
            if(self.rapportiDelegati){
              angular.forEach(self.rapportiDelegati, function (rapporto, index) {
        		self.contiCorrenteProvvisorio.push(rapporto);
              });
            }
            
            self.rapportiDelegati = [];

            self.preparaGrigliaconti();
            
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };
    
    this.ricercaRapportiDelegati = function (ndgList) {
    	self.listaNdg = [];
    	angular.forEach(ndgList, function (ndg, index) {
			   self.listaNdg.push(ndg);
        });
    	self.spinner.showSpinner++;
    	 self.propostaCartaDebitoIntSrvc
         .promiseRicercaRapportiDelegati(self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg)
         .then(
           function (response,ndgList) {
        	   self.rapportiDelegati = [];
        	   if(response && response.data && response.data.result && response.data.result.length > 0){
        		   angular.forEach(response.data.result, function (rapporto, index) {
        			   self.rapportiDelegati.push(rapporto);
                   });
        		   console.log('Rapporti delegati inseriti:  ' + self.rapportiDelegati.length);
        	   }

        	   if (self.idPratica) {
                 self.recuperaDatiAggiuntiviDefinizione(self.listaNdg);
               } else {
                 self.caricaContiCorrente(self.listaNdg);
               }
           },
           function (reason) {
             self.messaggiFctr.processaResponse(reason);
           }
         )
         .finally(function () {
           self.spinnerCliente.showSpinner--;
         });
    }
    
    this.preparaGrigliaconti = function () {
    	self.contiCorrente = [];
    	angular.forEach(self.contiCorrenteProvvisorio, function (rapporto, index) {
    		self.contiCorrente.push(rapporto);
          });
        self.altezzaTabellaConti = self.contiCorrente.length * self.altezzaRigaConto + 40;

        self.contiGridOptions = {
          enableSorting: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          enableColumnMenus: false,
          enableGrouping: false,
          multiSelect: false,
          showHeader: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          enableRowHeaderSelection: false,
          enableRowSelection: !self.propostaCartaDebitoIntSrvc.praticaIsReadOnly(),
          showGridFooter: false,
          enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableColumnResizing: true,
          columnDefs: [
            {
              displayName: $scope.msg('label.definizione.rapporto.numero'),
              field: 'numeroRapporto',
              width: '10%',
              name: 'numeroRapporto'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.iban'),
              field: 'iban',
              width: '25%',
              name: 'iban'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.descrizione'),
              field: 'descrizione',
              width: '15%',
              name: 'descrizione'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.saldocontabile'),
              cellFilter: 'number : 2',
              cellClass: 'right',
              field: 'saldo',
              width: '10%',
              name: 'saldoContabile'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.intestazione'),
              field: 'intestatario',
              width: '20%',
              name: 'intestazione'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.stato'),
              field: 'stato',
              width: '10%',
              name: 'stato'
            },
            {
              displayName: $scope.msg('label.definizione.rapporto.dataapertura'),
              field: 'dataApertura',
              cellFilter: 'date: "dd/MM/yyyy"',
              width: '10%',
              name: 'dataApertura'
            }
          ],
          data: self.contiCorrente,
          onRegisterApi: function (gridApi) {
            gridApi.grid.modifyRows(self.contiGridOptions.data);

            // Se era già stato salvato il conto corrente lo recupero e lo seleziono
            if (
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
            ) {
              angular.forEach(self.contiCorrente, function (conto, index) {
                if (
                  conto.numeroRapporto === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.numeroRapporto &&
                  conto.iban === self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban
                ) {
                  gridApi.selection.selectRow(self.contiCorrente[index]);
                }
              });
            }

            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              self.selezionaConto(row);
            });
          }
        };
    };

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     * @param ndgList Lista deli ndg da passare al recupero dei conti correnti
     */
    this.recuperaDatiAggiuntiviDefinizione = function (ndgList) {
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promiseRecuperaDatiAggiuntivi(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (response.data.result) {
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = response.data.result;
            }

            self.caricaContiCorrente(ndgList);

            if (
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore
            ) {
              self.ricercaNdg = self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore;
              self.ricercaUtilizzatori();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(response);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      if (self.idPratica) {
        self.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .promiseRecuperaProdottoPerIdPratica(self.idPratica)
          .then(function (response) {
            if (response && response.data && response.data.result) {
              self.idProdotto = response.data.result.idProdottoCPT;
            }
            self.spinner.showSpinner++;
            $q.all([
              self.propostaCartaDebitoIntSrvc.promiseRecuperaDatiAggiuntivi(self.idPratica),
              self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagrafica(self.idPratica),
              self.propostaCartaDebitoIntSrvc.promiseRecuperaTipoCarta(self.idProdotto)
            ])
              .then(function (response) {
                self.trattaResponse(response);
              })
              .finally(function () {
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
              });
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.spinner.showSpinner++;
        $q.all([
          self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagraficaPic(self.propostaCartaDebitoIntSrvc.ndg),
          self.propostaCartaDebitoIntSrvc.promiseRecuperaTipoCarta(self.idProdotto)
        ])
          .then(function (response) {
            self.trattaResponse(response);
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    this.recuperaListaNdg = function () {
      self.spinner.showSpinner++;
      var ndgList = [];

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.intestatario &&
        self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
      ) {
        // Inizializzo la lista degli ndg inserendo l'ndg dell'utente attuale
        ndgList = [self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg];
      }

      if (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS) {
        if (self.idPratica) {
          self.recuperaDatiAggiuntiviDefinizione(ndgList);
        } else {
          self.caricaContiCorrente(ndgList);
        }
      } else if (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER) {
        $q.all([
          self.propostaCartaDebitoIntSrvc.promiseRecuperaAnagraficaCoi(
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        ])
          .then(function (response) {
            if (response[0].data.result.length > 0) {
              console.log('Ndg trovati ' + response[0].data.result);
              angular.forEach(response[0].data.result, function (ndg, index) {
                ndgList.push(ndg);
              });
              console.log('Ndg inseriti ' + ndgList);
            }
            
            //Recupero i rapporti in cui sono delegato e poi faccio
            self.ricercaRapportiDelegati(ndgList);
            //Questa logica spostata dentro ricercaRapportiDelegati
            //Mi arriva la lista degli ndg per recuperare i CC
//            if (self.idPratica) {
//              self.recuperaDatiAggiuntiviDefinizione(ndgList);
//            } else {
//              self.caricaContiCorrente(ndgList);
//            }
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner = 0;
            }
          });
      }
    };

    this.trattaResponse = function (responses) {
      console.log(responses);
      // Anagrafica
      if (responses && responses.length > 0) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita = {};
        // Dati già salvati
        // Se avevo l'idPratica allora ho fatto 3 chiamate e posso prevalorizzare
        if (
          responses.length > 2 &&
          responses[0] &&
          responses[0].data &&
          !self.messaggiFctr.processaResponse(responses[0])
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi = responses[0].data.result;
          if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
          }
          self.propostaCartaDebitoIntSrvc.currentTipoCarta = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta;
        }

        // Se non avevo l'idPratica allora ho fatto due chiamate da cui recupero l'anagrafica
        // In particolare i dati anagrafici si troveranno in posizione 1 se avevo l'idPratica,
        // oppure in posizione 0 se non l'avevo
        var position = responses.length >= 3 ? 1 : 0;

        //TODO rimuovere perchè estrapolata, le logiche di selezione degli ndg è spostata a back
        //        // Le chiamate per popolare i conti correnti necessitano di sapere dalla chiamata di anagrafica se
        //        // ci sono dei conti cointestati. Tale parametro si trova in
        //        // responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione, che è un array di
        //        // dettagli di cointestazioni. I conti correnti devono essere recuperati sia per small business che per consumer
        //        // ma solo per la consumer vengono controllati i cointestati
        //        if (
        //          (self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
        //            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER) &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica.intestatario &&
        //          self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
        //        ) {
        //          // Inizializzo la lista degli ndg inserendo l'ndg dell'utente attuale
        //          var ndgList = [self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg];
        //          // Se siamo in consumer aggiungo gli ndg dei cointestati
        //          if (
        //            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
        //            responses &&
        //            responses.length > 0 &&
        //            responses[position] &&
        //            responses[position].data &&
        //            responses[position].data.result &&
        //            responses[position].data.result.anagrafica &&
        //            responses[position].data.result.anagrafica.relazioniAnagrafiche &&
        //            responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione
        //          ) {
        //            for (var i = 0; i < responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione.length; i++) {
        //              if (
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato &&
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato
        //                  .formaCostitutiva === 'COI' &&
        //                responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato.ndg
        //              ) {
        //                ndgList.push(
        //                  responses[position].data.result.anagrafica.relazioniAnagrafiche.relazione[i].relazionato.ndg
        //                );
        //              }
        //            }
        //          }
        //          // Se c'è idPratica chiamo il servizio per recueperare i dati aggiuntivi di definizione
        //          // attraverso la funzione recuperaDatiAggiuntiviDefinizione (la quale richiama anche
        //          // caricaContoCorrente), altrimenti mi limito a chiamare caricaContoCorrente
        //          if (self.idPratica) {
        //            self.recuperaDatiAggiuntiviDefinizione(ndgList);
        //          } else {
        //            self.caricaContiCorrente(ndgList);
        //          }
        //        }

        // Init tipo carta
        if (
          responses &&
          responses.length > 1 &&
          responses[position + 1] &&
          responses[position + 1].data &&
          responses[position + 1].data.result &&
          responses[position + 1].data.result.length > 0
        ) {
          if (!self.propostaCartaDebitoIntSrvc.datiDefinizioneSB) {
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
              ndgUtilizzatore: null,
              numeroRapporto: null,
              iban: null,
              tipoCarta: null,
              idPraticaConto: null
            };
          }
          if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
          }
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta = responses[position + 1].data.result[0].codice;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta = responses[position + 1].data.result[0].codice;
        } else if (
          // In caso la risposta fallisca valorizzo di default questi due tipi di carte visto che questa è per
          // forza di tipo I1
          self.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT
        ) {
          {
            if (!self.propostaCartaDebitoIntSrvc.datiDefinizioneSB) {
              self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
                ndgUtilizzatore: null,
                numeroRapporto: null,
                iban: null,
                tipoCarta: null,
                idPraticaConto: null
              };
            }
            if (!self.propostaCartaDebitoIntSrvc.datiAggiuntivi) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi = {};
            }
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta = 'I1';
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.tipoCarta = 'I1';
          }
        }

        // Init dei dati
        if (responses && responses[position] && responses[position].data) {
          // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
          // dei dati mancanti nell'anagrafica. Quindi imposto il flag è disabilito il bottone
          // per proseguire
          self.anagraficaIncompleta = self.messaggiFctr.processaResponse(responses[position]);
          self.datiAnagrafici =
            responses[position].data.result && responses[position].data.result.anagrafica
              ? responses[position].data.result.anagrafica
              : {
                  contatti: {},
                  documentoIdentificativo: {},
                  indirizzoPrincipale: {},
                  indirizzoSpedizione: null
                };

          self.datiAnagraficiOriginali =
            responses[position].data.result && responses[position].data.result.anagraficaOriginale
              ? responses[position].data.result.anagraficaOriginale
              : {
                  contatti: {},
                  documentoIdentificativo: {},
                  indirizzoPrincipale: {},
                  indirizzoSpedizione: null
                };

          // Prevalorizzazione ente rilascio
          // Se non è presente nei dati aggiuntivi lo prendo da anagrafica
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            ((self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio) ||
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio)
          ) {
            if (self.datiAnagrafici.documentoIdentificativo) {
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita = { datiEnteRilascio: {} };
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio = {
                enteRilascio: null
              };
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio =
                self.datiAnagrafici.documentoIdentificativo.enteRilascioDocumento;
              console.log(
                'ente: ' +
                  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
              );
              // RecuperaDomini viene chiamato in sequenza dopo questa chiamata, quindi la valorizzazione
              // onChangeEnte di enteRilascio viene lasciata a recuperaDomini
            }
          }

          // Formattazione date
          if (
            self.datiAnagrafici.documentoIdentificativo &&
            self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
          ) {
            self.datiAnagrafici.documentoIdentificativo.rilascioDocumento =
              self.propostaCartaDebitoIntSrvc.millisToDate(
                self.datiAnagrafici.documentoIdentificativo.rilascioDocumento
              );
          }
          if (
            self.datiAnagrafici.documentoIdentificativo &&
            self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
          ) {
            self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento =
              self.propostaCartaDebitoIntSrvc.millisToDate(
                self.datiAnagrafici.documentoIdentificativo.scadenzaDocumento
              );
          }

          // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
          if (
            !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia)
          ) {
            // L'indirizzo da utilizzare per la prevalorizzazione è quello del domicilio se presente, altrimenti quello di residenza
            self.indirizzoPrevalorizzazione = self.datiAnagrafici.indirizzoCorrispondenza
              ? self.datiAnagrafici.indirizzoCorrispondenza
              : self.datiAnagrafici.indirizzoPrincipale;

            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione = {
              via: self.indirizzoPrevalorizzazione.via,
              numero: null,
              provincia: self.indirizzoPrevalorizzazione.provincia,
              comune: {
                valore: self.indirizzoPrevalorizzazione.comune ? self.indirizzoPrevalorizzazione.comune.codice : null
              },
              cap: self.indirizzoPrevalorizzazione.cap,
              nazione: self.indirizzoPrevalorizzazione.nazione,
              localita: self.indirizzoPrevalorizzazione.localita
            };

            // provo a recuperare l'indirizzo ed il civico (se riesco)
            try {
              var datiIndirizzoCivico = self.propostaCartaDebitoIntSrvc.getStreetNumber(
                self.indirizzoPrevalorizzazione.via
              );
              if (datiIndirizzoCivico) {
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via =
                  self.propostaCartaDebitoIntSrvc.checkComma(datiIndirizzoCivico.indirizzo);
                self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero = datiIndirizzoCivico.civico;
              }
            } catch (error) {}
          }
        }
      }

      if (self.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
        self.recuperaDomini();
      }
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice === '086') {
            self.provinceEnteRilascio = responses[1];
            self.provinceEnteRilascio = self.provinceEnteRilascio.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.provinceEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio = {
              codice: '**',
              descrizione: 'STATO ESTERO'
            };
            // Devo forzare la chiamata di onProvinciaChange perché non "sente" la valorizzazione
            self.onProvinciaChange();
          }
          self.tae = responses[2];
          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];

          // Riordina tae in ordine alfabetico
          self.tae.sort(function (a, b) {
            if (a.descrizione > b.descrizione) {
              return 1;
            } else if (a.descrizione === b.descrizione) {
              return 0;
            } else {
              return -1;
            }
          });

          // Se l'ente di rilascio è stato prevalorizzato allora devo aggiornarlo attraverso l'onChange
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
          ) {
            self.onEnteChange();
          }
          self.recuperaComuni(false, false);

          // Se è presente il valore provinciaRilascio, viene prevalorizzato nella select
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio &&
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice !== '**'
          ) {
            self.recuperaComuni(false, true);
          }

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }

          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * Funzione chiamata al change di provincia di documento identità. Setta correttamente la provincia
     * selezionata nel service e chiama recupera comuni
     */
    this.onProvinciaChange = function () {
      for (var i = 0; i < self.province.length; i++) {
        if (
          self.province[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.descrizione =
            self.province[i].descrizione;
          break;
        }
      }
      self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio = null;
      // Seleziona di provincia come stato estero
      if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice === '**') {
        self.comuniEnteRilascio = [{ codice: '**', descrizione: 'STATO ESTERO' }];
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio = {
          codice: '**',
          descrizione: 'STATO ESTERO'
        };
      } else {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice) {
          self.recuperaComuni(false, true);
        } else {
          self.comuniEnteRilascio = [];
        }
      }
    };

    /**
     * Funzione chiamata al change di comune di documento identità. Setta correttamente il comune
     * selezionato nel service
     */
    this.onComuneChange = function () {
      for (var i = 0; i < self.comuniEnteRilascio.length; i++) {
        if (
          self.comuniEnteRilascio[i].codice ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.codice
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.comuneRilascio.descrizione =
            self.comuniEnteRilascio[i].descrizione;
          break;
        }
      }
    };

    /**
     * Funzione chiamata al change di ente di documento identità. Setta correttamente l'ente
     * selezionato nel service
     */
    this.onEnteChange = function () {
      for (var i = 0; i < self.entiRilascio.length; i++) {
        if (
          self.entiRilascio[i].enteRilascio ===
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.enteRilascio
        ) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.id =
            self.entiRilascio[i].id;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.tipoDocumento =
            self.entiRilascio[i].tipoDocumento;
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.datiEnteRilascio.codiceEnteNexi =
            self.entiRilascio[i].codiceEnteNexi;
          break;
        }
      }
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori, isDocumentoIdentita) {
      var provincia = '';
      if (!isDocumentoIdentita) {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;
      } else {
        provincia = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.documentoIdentita.provinciaRilascio.codice;
      }

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        if (!self.isDocumentoIdentita) {
          self.comuni = [];
        } else {
          self.comuniEnteRilascio = [];
        }
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        if (!isDocumentoIdentita) {
          self.comuni = domain;
        } else {
          self.comuniEnteRilascio = domain;
        }
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        if (self.$stateParams.idProdotto) {
          self.idProdotto = self.$stateParams.idProdotto;
        }

        if (self.propostaCartaDebitoIntSrvc.datiPratica) {
          // Recupero specializzazione
          self.specializzazione = self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione;

          // Visualizzazione riepilogo
          if (
            self.propostaCartaDebitoIntSrvc.datiPratica.prodotto &&
            self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.descrizione
          ) {
            self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;
            self.tipoProdotto = self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.descrizione;
          }

          // Caricamento conti corrente
          if (
            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
            self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER
          ) {
            self.propostaCartaDebitoIntSrvc.datiDefinizioneSB = {
              ndgUtilizzatore: null,
              numeroRapporto: null,
              iban: null,
              tipoCarta: null
            };
          }
        }

        self.recuperaAnagrafica();
        if (
          self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS ||
          self.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER
        ) {
          self.recuperaListaNdg();
        }
      });
    };
    self.init();
  };

  CdintDefinizioneCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDefinizione/cdintDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDefinizioneComponent = {
    controller: CdintDefinizioneCtrl,
    controllerAs: 'cdintDefinizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDefinizione', CdintDefinizioneComponent);
})();


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDocumenti
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function() {
    'use strict';
    var CdintDocumentiCtrl = function(
        $http,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        labelSrvc,
        messaggiFctr,
        propostaCartaDebitoIntSrvc,
        $uibModal,
        userSrvc
    ) {
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$cacheFactory = $cacheFactory;
        this.messaggiFctr = messaggiFctr;
        this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
        this.CONSTANTS = CONSTANTS;
        this.$uibModal = $uibModal;
        this.userSrvc = userSrvc,
        $scope.msg = labelSrvc.getLabel;

        /**
         * Indica se il caricamento delle labels è andato a buon fine
         */
        this.labelsPronte = false;

        /**
         * Indica se la pratica è già presa in carico
         */
        this.isPresaInCarico = false;

        /**
         * Indica se la pratica è già presa in carico
         */
        this.isRilasciaPratica = false;

        /**
         * Riferimento allo spinner globale
         */
        this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

        /**
         * Copia dei dati pratica
         */
        this.datiPratica = null;

        /**
         * Flag che indica se prosegui è abilitato
         */
        this.isStatoCorretto = false;

        /**
         * Flag che indica se tutti i documenti sono stati firmati
         */
        this.documentiFirmati = false;

        /**
         * Riferimento interno al controller per recuperare i valori nelle funzioni
         */
        var self = this;

        /**
         * Implementazione nel service della funzione di abilitazione torna indietro nella pratica
         */
        this.propostaCartaDebitoIntSrvc.indietroAbilitato = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
         */
        this.propostaCartaDebitoIntSrvc.salvaAbilitato = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
         */
        this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function() {
            return self.getIsStatoCorretto() && self.documentiFirmati;
        };

        /**
         * Implementazione nel service della funzione di visualizzazione bottone prosegui
         */
        this.propostaCartaDebitoIntSrvc.proseguiVisibile = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione completaVisibile
         */
        this.propostaCartaDebitoIntSrvc.completaVisibile = function() {
            //    	return self.getIsStatoCorretto();
            if (
                (!self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile() &&
                    self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
                		!(self.propostaCartaDebitoIntSrvc.checkCanale(self.datiPratica.canale, self.userSrvc.user.app)))
            ) {
                return true;
            } else {
                return false;
            }
        };
        
        /**
         * Implementazione nel service della funzione rifiutaVisibile
         */
        this.propostaCartaDebitoIntSrvc.rifiutaVisibile = function() {
            //    	return self.getIsStatoCorretto();
            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
                return true;
            } else {
                return false;
            }
        };

        /**
         * Verifico se la pratica si trova in uno degli stati da cui è possibile avviare il completamento
         * @returns
         */
        this.getIsStatoCorretto = function() {
            return (
                self.datiPratica &&
                ((self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 3) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 6) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 1) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 2) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 3))
            );
        };

        /**
         * Resta in ascolto del cambiamento sulla listaStatiDocumenti che contiene i documenti firmati
         */
        $scope.$watch(
            'listaStatiDocumenti',
            function(newValue, oldValue, $scope) {
                // aggiorno i dati della pratica da quelli restituiti dal widget documentale nello scope
                self.datiPratica = $scope.cdintDocumentiCtrl.datiPratica;

                if (angular.isArray(newValue)) {
                    if (newValue.length === 0) {
                        self.documentiFirmati = true;
                    } else {
                        self.documentiFirmati = !newValue.find(function(value) {
                            return !value.stateValid;
                        });
                    }
                }
            },
            true
        );

        this.verificaPresaInCarico = function() {
            this.propostaCartaDebitoIntSrvc
                .promiseVerificaPresaInCarico(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
                .then(
                    function(response) {
                        if (self.messaggiFctr.processaResponse(response)) {
                            return;
                        }

                        if (response.data.presaInCaricoAbilitata) {
	                        if (!response.data.presaInCaricoInCorso) {
	                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
	                                self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
	                                    return true;
	                                };
	                            }
	
	                            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
	                                return false;
	                            };
	                        } else {
	                            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
	                                return false;
	                            };
	                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
	                                self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
	                                    return true;
	                                };
	                            }
	                        }
                        }else {
                        	self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
                                return false;
                            };
                            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
                                return false;
                            };
                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
                                self.propostaCartaDebitoIntSrvc.completaVisibile = function() {
                                    return false;
                                };
                                self.propostaCartaDebitoIntSrvc.rifiutaVisibile = function() {
                                	return false;
                                };
    						}
                        }
                    },
                    function(reason) {
                        self.messaggiFctr.processaResponse(reason);

                        self.loggerSrvc.log(
                            'CdintPropostaCartaDebitoIntCtrl',
                            self.loggerSrvc.SEVERE,
                            'Errore verifica PresaInCarico per la pratica ID ' +
                            self.idPratica +
                            ': ' +
                            self.loggerSrvc.formattaMessaggio(reason)
                        );
                    }
                );
        };

        /**
         *  Funzione richiamata all'avvio del controller
         */
        this.init = function() {
            labelSrvc.labelsPronte.then(function() {
                self.labelsPronte = true;

                // Copio i dati pratica e forzo la creazione del campo naturaGiuridica sull'intestatario
                // per compatibilità con gli widget
                var newDatiPratica = JSON.parse(JSON.stringify(self.propostaCartaDebitoIntSrvc.datiPratica));
                if (newDatiPratica) {
                    newDatiPratica.intestatario.naturaGiuridica = newDatiPratica.intestatario.formaCostitutiva;
                    self.datiPratica = newDatiPratica;
                    self.isStatoCorretto = self.getIsStatoCorretto();
                }

                self.verificaPresaInCarico();
            });
        };

        self.init();
    };

    CdintDocumentiCtrl.$inject = [
        '$http',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'CDINT_CONSTANTS',
        'CdintLabelSrvc',
        'CdintMessaggiFctr',
        'CdintPropostaCartaDebitoIntSrvc',
        '$uibModal',
        'CdintUserSrvc',
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintDocumenti/cdintDocumenti.html'
        );
    };

    TemplateUrl.$inject = ['CDINT_CONSTANTS'];

    var CdintDocumentiComponent = {
        controller: CdintDocumentiCtrl,
        controllerAs: 'cdintDocumentiCtrl',
        templateUrl: TemplateUrl
    };

    angular.module('cbl.cartadebitoint.wa').component('cdintDocumenti', CdintDocumentiComponent);
})();

/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintModalAnnulla
 * @restrict E
 * @description Componente per avviare l'annullamento di una proposta di carta debito internazionale
 */
(function () {
  'use strict';
  var CdintModalAnnullaCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModalInstance
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModalInstance = $uibModalInstance;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Note inserite nella textarea
     */
    this.note;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Funzione abbinata al pulsante di chiusura in alto e annulla in basso
     * Chiude la modale senza avviare la chiamata di annullamento
     */
    this.chiudiModale = function () {
      self.$uibModalInstance.dismiss();
    };

    /**
     * Funzione abbinata al pulsante "conferma" della modale, avvia la chiamata di annullamento
     */
    this.annullaProposta = function () {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avvio annullamento per la pratica ID ' + self.idPratica
      );

      self.propostaCartaDebitoIntSrvc
        .promiseAnnullaPratica(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            ? self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica,
          self.note
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Annullamento completato per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            self.$uibModalInstance.close(true);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore annullamento per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };
  };

  CdintModalAnnullaCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModalInstance'
  ];

  angular.module('cbl.cartadebitoint.wa').controller('cdintModalAnnullaController', CdintModalAnnullaCtrl);
})();


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintModalRifiuta
 * @restrict E
 * @description Componente per avviare il rifiuto di una proposta di carta debito internazionale
 */
(function () {
  'use strict';
  var CdintModalRifiutaCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModalInstance
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModalInstance = $uibModalInstance;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Note inserite nella textarea
     */
    this.note;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Funzione abbinata al pulsante di chiusura in alto e annulla in basso
     * Chiude la modale senza avviare la chiamata di rifiuto
     */
    this.chiudiModale = function () {
      self.$uibModalInstance.dismiss();
    };

    /**
     * Funzione abbinata al pulsante "conferma" della modale, avvia la chiamata di rifiuto
     */
    this.rifiutaProposta = function () {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avvio rifiuta per la pratica ID ' + self.idPratica
      );

      self.propostaCartaDebitoIntSrvc
        .promiseRifiutaPratica(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            ? self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica,
          self.note
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Rifiuto completato per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            self.$uibModalInstance.close(true);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore rifiuta per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };
  };

  CdintModalRifiutaCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModalInstance'
  ];

  angular.module('cbl.cartadebitoint.wa').controller('cdintModalRifiutaController', CdintModalRifiutaCtrl);
})();


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintPropostaCartaDebitoIntCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Parametri passati dalla rotta ndg + id prodotto
     * Necessari per la creazione della pratica
     */
    this.ndg;

    /**
     * Id del prodotto recuperato dalla path
     */
    this.idProdotto;

    /**
     * Id del target market recuperato dalla path
     */
    this.idTargetMarket;

    /**
     * Parametro passato dalla rotta con solo id pratica
     */
    this.idPratica;

    /**
     * Tabs di primo livello
     */
    this.TAB_LIST_MACRO = [];

    /**
     * Tabs di secondo livello
     */
    this.TAB_LIST_MICRO = {};

    /**
     * Tab attivo
     */
    this.currentTabMacro = {};

    /**
     * Sottotab attivo
     */
    this.currentTabMicro = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     * Pulsante annullamento pratica
     * Lancia la chiamata di annullamento
     */
    this.annullaPratica = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Aperta modale per richiesta annullamento sulla pratica ID ' + self.idPratica
      );

      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'cdintPropostaCartaDebitoInt/cdintModalAnnulla/cdintModalAnnulla.html',
          controller: 'cdintModalAnnullaController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(
          function (res) {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta annullamento con operazione completata per la pratica ID ' + self.idPratica
            );

            self.$state.go('schedaCliente', {
              ndg: self.ndg,
              idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
            });
          },
          function () {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta annullamento senza esecuzione richiesta per la pratica ID ' + self.idPratica
            );
          }
        );
    };

    /**
     * Pulsante annullamento pratica
     * Lancia la chiamata di annullamento
     */
    this.rifiutaPratica = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Aperta modale per richiesta rifiuta sulla pratica ID ' + self.idPratica
      );

      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'cdintPropostaCartaDebitoInt/cdintModalRifiuta/cdintModalRifiuta.html',
          controller: 'cdintModalRifiutaController',
          controllerAs: 'modalRifiutaCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(
          function (res) {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta rifiuto con operazione completata per la pratica ID ' + self.idPratica
            );

            self.$state.go('schedaCliente', {
              ndg: self.ndg,
              idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
            });
          },
          function () {
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Chiusa modale per richiesta rifiuto senza esecuzione richiesta per la pratica ID ' + self.idPratica
            );
          }
        );
    };

    //        /**
    //         * Pulsante rifiuta pratica
    //         * Lancia la chiamata di rifiuta
    //         */
    //        this.rifiutaPratica = function () {
    //          self.spinner.showSpinner++;
    //
    //          self.loggerSrvc.log(
    //            'CdintPropostaCartaDebitoIntCtrl',
    //            self.loggerSrvc.INFO,
    //            'Avvio rifiuto per la pratica ID ' + self.idPratica
    //          );
    //
    //          self.propostaCartaDebitoIntSrvc
    //            .promiseRifiutaPratica(
    //              self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
    //                ? self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
    //                : self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica,
    //              self.note
    //            )
    //            .then(
    //              function (response) {
    //                if (self.messaggiFctr.processaResponse(response)) {
    //                  return;
    //                }
    //
    //                self.loggerSrvc.log(
    //                  'CdintPropostaCartaDebitoIntCtrl',
    //                  self.loggerSrvc.INFO,
    //                  'Rifiuto completato per la pratica ID ' + self.idPratica
    //                );
    //
    //                self.$state.go('schedaCliente', { ndg: self.ndg , idAnagrafica : self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica });
    //              },
    //              function (reason) {
    //                self.messaggiFctr.processaResponse(reason);
    //
    //                self.loggerSrvc.log(
    //                  'CdintPropostaCartaDebitoIntCtrl',
    //                  self.loggerSrvc.SEVERE,
    //                  'Errore annullamento per la pratica ID ' +
    //                    self.idPratica +
    //                    ': ' +
    //                    self.loggerSrvc.formattaMessaggio(reason)
    //                );
    //              }
    //            )
    //            .finally(function () {
    //              if (self.spinner.showSpinner > 0) {
    //                self.spinner.showSpinner--;
    //              }
    //            });
    //        };

    /**
     * Verifica se per il macro step indicato esistono i micro-step
     */
    this.microStepPresenti = function (codiceMacroStep) {
      return self.TAB_LIST_MICRO[codiceMacroStep] && self.TAB_LIST_MICRO[codiceMacroStep].length > 0;
    };

    /**
     * Navigazione verso lo step precedente
     */
    this.indietro = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Arretramento di step per la pratica ID ' + self.idPratica
      );

      var stepIndex = self.TAB_LIST_MACRO.indexOf(self.currentTabMacro);
      var substepIndex = 0;

      if (self.microStepPresenti(self.currentTabMacro.step)) {
        substepIndex = self.TAB_LIST_MICRO[self.currentTabMacro.step].indexOf(self.currentTabMicro);
      }

      if (stepIndex === 0 && substepIndex === 0) {
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          'Errore arretramento di step per la pratica ID ' +
            self.idPratica +
            ', tentativo di arretrare ad uno step con indice negativo'
        );

        return;
      }

      // Reimposto le funzioni di abilitazione della pulsantiera prima di passare di step
      // Lo step riassegnerà i propri nell'inizializzazione
      self.resetAbilitazioni();

      // Se ho indice substep > 0 ho sicuramente un micro-tab precedente ed indietreggio su quello
      // Altrimenti vado al macro-tab precedente, dove verifico se ho micro-tab
      if (substepIndex > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][substepIndex - 1];
      } else {
        self.currentTabMicro = null;
        self.currentTabMacro = self.TAB_LIST_MACRO[stepIndex - 1];

        if (self.microStepPresenti(self.currentTabMacro.step)) {
          var lastIndex = self.TAB_LIST_MICRO[self.currentTabMacro.step].length - 1;
          self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][lastIndex];
        }
      }

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Arretramento di step completato per la pratica ID ' +
          self.idPratica +
          ': step ' +
          self.currentTabMacro.title +
          (self.currentTabMicro ? ' / ' + self.currentTabMicro.title : '')
      );
    };

    /**
     * Richiamato nelle funzioni salva e prosegui, lancia la chiamata abbinata allo stato e step pratica
     * e, se specificato, applica il flag per il solo salvataggio
     */
    this.eseguiSalvataggioStep = function (prosegui) {
      var stato = null;
      var step = null;

      // Recupero la prima combinazione, poiché la chiamate per completare ogni tab sono le solite
      if (self.currentTabMicro) {
        stato = self.currentTabMicro.statoPratica[0].stato;
        step = self.currentTabMicro.statoPratica[0].step;
      } else {
        stato = self.currentTabMacro.statoPratica[0].stato;
        step = self.currentTabMacro.statoPratica[0].step;
      }

      switch (stato) {
        case CONSTANTS.STATO_PRATICA.IN_CORSO:
        case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
          // A seconda della specializzazione le chiamate da eseguire sono diverse
          switch (self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione) {
            case CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
            case CONSTANTS.SPECIALIZZAZIONI.CONSUMER:
              switch (step) {
                case 1:
                  self.checkIbanAndConfermaProdotto(prosegui, true);
                  //self.confermaProdotto(prosegui, true);
                  break;
                case 2:
                  self.confermaDatiAggiuntivi(
                    prosegui,
                    self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.CONSUMER
                      ? 2
                      : 1
                  );
                  break;
                case 3:
                  // nel caso della consumer faccio salvataggio questionario.
                  if (
                    self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.CONSUMER
                  ) {
                    self.confermaQuestionari(prosegui);
                  } else self.confermaDatiAggiuntivi(prosegui, 2);
                  break;
                case 4:
                  self.confermaQuestionari(prosegui);
                  break;
              }
              break;
            default:
              switch (step) {
                case 1:
                  self.confermaProdotto(prosegui, false);
                  break;
                case 2:
                  // rivedere per aml
                  self.confermaDatiAml(prosegui, null);
                  break;
                case 3:
                  self.confermaQuestionari(prosegui);
                  break;
              }
              break;
          }
          break;
      }
    };

    /**
     * Salvataggio dello stato della pratica
     */
    this.salva = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio della pratica ID ' +
          self.idPratica +
          ': stato attuale ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(false);
    };

    /**
     * Proseguimento allo step successivo della pratica
     * O, se ci troviamo all'ultimo step, completamento
     */
    this.avanza = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avanzamento di step per la pratica ID ' +
          self.idPratica +
          ': stato attuale ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(true);
    };

    this.recuperaContoCorrente = function () {
      if (self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
        self.spinner.showSpinner++;

        self.propostaCartaDebitoIntSrvc
          .promiseDettaglioContoCorrente(self.idPratica)
          .then(function (response) {
            // Anagrafica
            if (response && response.data.result) {
              // Se ci sono messaggi di errore nella risposta vuol dire che ci sono
              // dei dati mancanti nell'anagrafica. QUindi imposto il flag è disabilito il bottone
              // per proseguire
              self.propostaCartaDebitoIntSrvc.datiPratica.iban = response.data.result.item.iban;
            }
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    this.confermaProdottoEsistente = function (prosegui, inviaDatiPG) {
      //Controllo che la pratica sia esistente
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        '[confermaProdottoEsistente] Conferma prodotto per la pratica ID ' + self.idPratica + ' self.idProdotto ' + self.idProdotto 
      );

      self.spinner.showSpinner++;

      // inserire nei dati aggiuntivi anche il prodotto selezionato.
      if (
        !inviaDatiPG &&
        self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT
      ) {
        self.idProdotto = self.propostaCartaDebitoIntSrvc.datiPratica.prodotto.idProdottoCPT;
        self.loggerSrvc.log(
	       'CdintPropostaCartaDebitoIntCtrl',
	       self.loggerSrvc.INFO,
	       '[confermaProdottoEsistente] Se sono LIGHT Conferma prodotto per la pratica ID ' + self.idPratica + ' self.idProdotto ' + self.idProdotto 
	    );
      }

      if(self.propostaCartaDebitoIntSrvc.datiAggiuntivi && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione && 
    		  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via){
    	  self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via = self.propostaCartaDebitoIntSrvc.checkComma(self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via.toUpperCase());
      }
      
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        '[confermaProdottoEsistente] Dati inviati: idPratica ' + self.idPratica + '  e idProdotto ' + self.idProdotto 
      );
      return self.propostaCartaDebitoIntSrvc
        .promiseDefinizioneProdotto(
          self.idPratica,
          self.idProdotto,
          inviaDatiPG
            ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi,
          prosegui
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma prodotto completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
            // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
            self.propostaCartaDebitoIntSrvc.isRedirecting = true;
            self.$state.go(
              'cdint-proposta-carta-debito-int-pratica',
              {
                idPratica: self.idPratica
              },
              { reload: true }
            );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma prodotto per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.confermaProdotto = function (prosegui, inviaDatiPG) {
      if (self.propostaCartaDebitoIntSrvc.datiPratica.idPratica) {
        self.confermaProdottoEsistente(prosegui, inviaDatiPG);
      } else {
        self.creaPratica(prosegui, inviaDatiPG);
      }
    };

    this.checkIbanAndConfermaProdotto = function (prosegui, inviaDatiPG) {
      self.spinner.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseCheckIbanAndConfermaProdotto(self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.confermaProdotto(prosegui, inviaDatiPG);
          },

          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore checkIbanAndConfermaProdotto' + self.loggerSrvc.formattaMessaggio(reason)
            );
            return;
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione che verifica se il tab specificato è abilitato per lo stato/step indicati
     * Step può essere null, in quel caso sarà verificato solo lo stato
     */
    this.tabContieneStatoStep = function (tab, stati, step) {
      if (!(tab && tab.statoPratica)) {
        return false;
      }

      if (!(stati && stati.length > 0)) {
        return false;
      }

      for (var i = 0; i < tab.statoPratica.length; i++) {
        if (stati.indexOf(tab.statoPratica[i].stato) > -1 && (!step || tab.statoPratica[i].step === step)) {
          return true;
        }
      }

      return false;
    };

    this.confermaDatiAml = function (prosegui, sottostep) {
      if (prosegui) {
        self.spinner.showSpinner++;
        self.propostaCartaDebitoIntSrvc
          .proseguiAml()
          .then(
            function (response) {
              // richiamo in cascata il cartadebitoint-mf per salvataggio step.
              if (response.isLastAfter) {
                // chiamo lo step di prosegui.

                // Recupero dal service, ma per default è nominativa
                self.callPromiseDatiAml(prosegui, {
                  tipoCarta:
                    self.propostaCartaDebitoIntSrvc.datiDefinizioneSB &&
                    self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta
                      ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.tipoCarta
                      : 'I1',
                  idPratica: self.idPratica
                });
              }
            },

            function (reason) {
              self.messaggiFctr.processaResponse(reason);

              self.loggerSrvc.log(
                'CdintPropostaCartaDebitoIntCtrl',
                self.loggerSrvc.SEVERE,
                'Errore conferma dati aggiuntivi per la pratica ID ' +
                  self.idPratica +
                  ': ' +
                  self.loggerSrvc.formattaMessaggio(reason)
              );
            }
          )
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.spinner.showSpinner++;
        // salvataggio
        self.propostaCartaDebitoIntSrvc
          .salvaAml()
          .then()
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    /**
     * Funzione eseguita dal prosegui del secondo step, conferma i dati aggiuntivi
     * Nel caso di specializzazione Smallbusiness (SDI) si passa anche il sotto-step per identificare il passaggio da salvare
     */
    this.confermaDatiAggiuntivi = function (prosegui, sottostep) {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Conferma dati aggiuntivi per la pratica ID ' + self.idPratica
      );

      // A seconda dello step in cui mi trovo, invio dati diversi al servizio
      // Sottostep null: specializzazione light
      // Sottostep 1: specializzazione SDI, dati persona giuridica
      // Sottostep 2: specializzazione SDI, dati persona fisica
      var datiAggiuntivi = null;
      switch (sottostep) {
        case null:
        case undefined:
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntivi;
          break;
        case 1:
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPg;
          break;
        case 2:
          // check sulla parte di indirizzo residenza o spedizione
          if (self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf) {
            this.propostaCartaDebitoIntSrvc.copiaIndirizzoResidenzaInSpedizione();
          }
          datiAggiuntivi = self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf
            ? self.propostaCartaDebitoIntSrvc.datiAggiuntiviPf
            : self.propostaCartaDebitoIntSrvc.datiAggiuntivi;
          break;
      }

      if (!datiAggiuntivi) {
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.ERROR,
          'Chiamata di salvataggio dati aggiuntivi non validi per la pratica ' +
            self.idPratica +
            '. Step specificato: ' +
            sottostep
        );
        return;
      }

      self.callPromiseDatiAggiuntivi(prosegui, datiAggiuntivi, sottostep);
    };

    this.callPromiseDatiAggiuntivi = function (prosegui, datiAggiuntivi, sottostep) {
      self.spinner.showSpinner++;
      console.log(
        '[callPromiseDatiAggiuntivi] idPratica: ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica +
          ' idPratica recuperata dai dati aggiuntivi: ' +
          datiAggiuntivi.idPratica
      );
      
      if(datiAggiuntivi && datiAggiuntivi.indirizzoSpedizione && datiAggiuntivi.indirizzoSpedizione.via){
    	  datiAggiuntivi.indirizzoSpedizione.via = self.propostaCartaDebitoIntSrvc.checkComma(datiAggiuntivi.indirizzoSpedizione.via.toUpperCase());
      }
      
      return self.propostaCartaDebitoIntSrvc
        .promiseDatiAggiuntivi(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica,
          datiAggiuntivi,
          prosegui,
          sottostep
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma dati aggiuntivi completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.callPromiseDatiAml = function (prosegui, datiAggiuntivi) {
      self.spinner.showSpinner++;

      return self.propostaCartaDebitoIntSrvc
        .promiseDatiAml(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica, datiAggiuntivi, prosegui)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Conferma dati aml completata per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aml per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione eseguita dal prosegui del terzo step, questionari. Salva il questionario compilato
     */
    this.confermaQuestionari = function (prosegui) {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio questionari per la pratica ID ' + self.idPratica
      );

      self.spinner.showSpinner++;

      return self.propostaCartaDebitoIntSrvc
        .promiseSaveQuestionari(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica,
          self.propostaCartaDebitoIntSrvc.questionari,
          prosegui
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Salvataggio questionari completato per la pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            // recupero l'iban se non impostato per qualche movito solo per la light.
            if (
              self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione === CONSTANTS.SPECIALIZZAZIONI.LIGHT &&
              !self.propostaCartaDebitoIntSrvc.datiPratica.iban
            )
              self.recuperaContoCorrente();

            if (prosegui) {
              self.resetAbilitazioni();
              self.attivaTabPerStatoPratica();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore salvataggio questionari per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.isPraticaPresentata = function () {
      return self.propostaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA;
    };

    /**
     * Funzione eseguita dal prosegui dell'ultimo step, richiamata ricorsivamente finché la pratica
     * non è in uno stato valido
     */
    this.completaPratica = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseProspettoPersonaFisica(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Prospetto persona fisica per la pratica ID ' + self.idPratica
            );

            self.datiProspetto = response.data.result;

            if (!self.datiProspetto) {
              self.completaPraticaDefinitivo();
            } else {
              self.controllaAccettazione();
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.controllaAccettazione = function () {
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseAccettazionePratica(self.datiProspetto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Controlla Accettazione per la pratica ID ' + self.idPratica
            );

            self.completaPraticaDefinitivo();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore conferma dati aggiuntivi per la pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    this.completaPraticaDefinitivo = function () {
      self.spinner.showSpinner++;
      return self.propostaCartaDebitoIntSrvc
        .promiseCompletaPratica(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
              if (self.spinner.showSpinner > 0) {
                self.spinner.showSpinner--;
              }
              return;
            }
            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
            // Dopo che si è caricato i documenti (stato pratica CONSOLIDATA 3/6) si effettua una prima chiamata al completa
            // che porta la pratica in PRESENTATA 1, dopodichè si esce dal wizard e la pratica viene trasferita in un'altra
            // coda lavoro (del backoffice) che si occupa di fare un'altra serie di chiamate al completa che portano la pratica
            // in PRESENTATA 3 e infine in ACCETTATA o DAREVISIONARE. UNa volta che la pratica è in uno di questi stati
            // o è conclusa (ACCETTATA) oppure (DAREVISIONARE) si procede col modificare i dati e riportare quindi la pratica in INCORSO 1
            // una volta cliccato sul "prosegui" presente nella pagina di definizione prodotto.
            switch (self.propostaCartaDebitoIntSrvc.datiPratica.stato) {
              case CONSTANTS.STATO_PRATICA.ACCETTATA:
              case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
                // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
                self.$state.go('schedaCliente', {
                  ndg: self.ndg,
                  idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
                });
                break;
              case CONSTANTS.STATO_PRATICA.PRESENTATA:
                // Ho portato la pratica da CONSOLIDATA 3 a PRESENTATA 1 quindi mi fermo, esco dal wizard
                // e la pratica viene trasferita in un'altra coda lavoro
                if (self.propostaCartaDebitoIntSrvc.datiPratica.step === 1) {
                  self.loggerSrvc.log(
                    'CdintPropostaCartaDebitoIntCtrl',
                    self.loggerSrvc.INFO,
                    'Passaggio da INCORSO a PRESENTATA per la pratica con id ' + self.idPratica
                  );
                  // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                  if (self.spinner.showSpinner > 0) {
                    self.spinner.showSpinner--;
                  }
                  self.$state.go('schedaCliente', {
                    ndg: self.ndg,
                    idAnagrafica: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.idAnagrafica
                  });
                } else {
                  // Se la pratica non ha raggiunto stato ACCETTATA o DAREVISIONARE, continuo a richiamare il servizio
                  // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                  if (self.spinner.showSpinner > 0) {
                    self.spinner.showSpinner--;
                  }
                  self.completaPraticaDefinitivo();
                }
                break;
              default:
                // Se la pratica non ha raggiunto stato ACCETTATA o DAREVISIONARE, continuo a richiamare il servizio
                // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
                if (self.spinner.showSpinner > 0) {
                  self.spinner.showSpinner--;
                }
                self.completaPraticaDefinitivo();
                break;
            }
          },
          function (reason) {
            // Devo diminuire showSpinner perché, essendo ricorsiva, a ogni ricorsione viene aumentato showSpinner
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          // In teoria non dovrebbe mai scendere sotto lo 0, tuttavia, essendo una chiamata asincrona e ricorsiva, è
          // stato aggiunto anche questo controllo per impedire a spinner di essere < 0
          if (self.showSpinner < 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };

    /**
     * Reimposta le funzioni di abilitazione e visualizzazione dei pulsanti a pié di pagina
     */
    this.resetAbilitazioni = function () {
      self.propostaCartaDebitoIntSrvc.indietroAbilitato = self.propostaCartaDebitoIntSrvc.defaultIndietroAbilitato;
      self.propostaCartaDebitoIntSrvc.salvaVisibile = self.propostaCartaDebitoIntSrvc.defaultSalvaVisibile;
      self.propostaCartaDebitoIntSrvc.salvaAbilitato = self.propostaCartaDebitoIntSrvc.defaultSalvaAbilitato;
      self.propostaCartaDebitoIntSrvc.proseguiAbilitato = self.propostaCartaDebitoIntSrvc.defaultProseguiAbilitato;
    };

    /**
     * Torna ad inizio pratica
     */
    this.inizioPratica = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        "Torno all'inizio del processo per la pratica ID " + self.idPratica
      );

      if (self.currentTabMacro !== self.TAB_LIST_MACRO[0]) {
        self.currentTabMacro = self.TAB_LIST_MACRO[0];
      } else {
        self.init();
      }
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (!self.propostaCartaDebitoIntSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Verifico se il tab ha sotto-tab
      if (self.TAB_LIST_MICRO[self.currentTabMacro.step] && self.TAB_LIST_MICRO[self.currentTabMacro.step].length > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][0];
      } else {
        self.currentTabMicro = null;
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function (currentTabIndex) {
      // Pratica navigabile
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() === true) {
        if (currentTabIndex === self.currentTabMicro.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMicro.index) {
        return 'ab-step-tabs';
      }

      if (currentTabIndex === self.currentTabMicro.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function (currentTabIndex) {
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() === true) {
        return 'step read';
      }

      if (currentTabIndex < self.currentTabMicro.index) {
        return 'step success';
      }

      return 'step';
    };

    /**
     * @ngdoc method
     * @name microTabClicked
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasRichiestaFido
     * @description Apre il micro-tab selezionato
     * @param {Object} tab - il micro-tab selezionato
     */
    this.microTabClicked = function (tab) {
      if (self.propostaCartaDebitoIntSrvc.isPraticaNavigabile() !== true) {
        return;
      }

      self.currentTabMicro = tab;
    };

    /**
     * In base allo step definito nel tab, recupera l'URL del template da visualizzare
     */
    this.getStepUrl = function (step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'SPEDIZIONE':
          return 'spedizione.tmpl.html';
        case 'DATIAGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        case 'DATIAML':
          return 'datiAml.tmpl.html';
        case 'DATIAGGIUNTIVIPG':
          return 'datiAggiuntiviPG.tmpl.html';
        case 'DATIAGGIUNTIVIPF':
          return 'datiAggiuntiviPF.tmpl.html';
        case 'QUESTIONARI':
          return 'questionari.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return null;
      }
    };

    /**
     * Funzione che dopo il recupero dei tab o dopo un cambio stato evidenzia il tab attivo
     * in base allo stato della pratica
     */
    this.attivaTabPerStatoPratica = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Attivazione tab per pratica ID ' +
          self.idPratica +
          ': Stato ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.stato +
          ', Step ' +
          self.propostaCartaDebitoIntSrvc.datiPratica.step
      );

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.stato &&
        self.propostaCartaDebitoIntSrvc.datiPratica.step
      ) {
        // Se la pratica è in stato di ACCETTATA apro direttamente
        // la prima tab e primo step visto che il wizard è navigabile
        if (self.propostaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.ACCETTATA) {
          self.currentTabMacro = self.TAB_LIST_MACRO[0];
          self.currentTabMicro = self.TAB_LIST_MICRO[0];
          return;
        }

        // Nel caso di pratica consolidata devo valutare solamente lo stato
        // Negli altri casi tutto il resto
        for (var i = 0; i < self.TAB_LIST_MACRO.length; i++) {
          var macroTab = self.TAB_LIST_MACRO[i];
          // Verifico se ho dei sotto-tab
          // In caso positivo imposto sia il macro-tab che il micro-tab
          if (!macroTab.statoPratica && self.TAB_LIST_MICRO[macroTab.step]) {
            for (var j = 0; j < self.TAB_LIST_MICRO[macroTab.step].length; j++) {
              var microTab = self.TAB_LIST_MICRO[macroTab.step][j];
              if (
                self.tabContieneStatoStep(
                  microTab,
                  [self.propostaCartaDebitoIntSrvc.datiPratica.stato],
                  self.propostaCartaDebitoIntSrvc.datiPratica.step
                )
              ) {
                self.currentTabMacro = macroTab;
                self.currentTabMicro = microTab;

                self.loggerSrvc.log(
                  'CdintPropostaCartaDebitoIntCtrl',
                  self.loggerSrvc.INFO,
                  'Apertura tab ' +
                    self.currentTabMacro.title +
                    '/' +
                    self.currentTabMicro.title +
                    ' per pratica ID ' +
                    self.idPratica
                );
                return;
              }
            }

            continue;
          }

          // Altrimenti solo il macro-tab
          if (
            self.tabContieneStatoStep(
              macroTab,
              [self.propostaCartaDebitoIntSrvc.datiPratica.stato],
              self.propostaCartaDebitoIntSrvc.datiPratica.step
            )
          ) {
            self.currentTabMacro = macroTab;
            self.currentTabMicro = null;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Apertura tab ' + self.currentTabMacro.title + ' per pratica ID ' + self.idPratica
            );

            return;
          }
        }
      }

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Apertura tab di default pratica ID ' + self.idPratica
      );

      self.currentTabMacro = self.TAB_LIST_MACRO[0];
      //EMonetica-630
      //Se lo stato della pratica è ANNULLATA o RIFIUTATA forzo il click al primo step
      if (
        self.propostaCartaDebitoIntSrvc.datiPratica.stato == CONSTANTS.STATO_PRATICA.ANNULLATA ||
        self.propostaCartaDebitoIntSrvc.datiPratica.stato == CONSTANTS.STATO_PRATICA.RIFIUTATA
      ) {
        self.macroTabClicked(self.currentTabMacro);
      }
    };

    /**
     * Funzione richiamata dopo il caricamento della pratica, recupera le tabs disponibili
     */
    this.recuperaTabs = function () {
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Elaborazione tabs pratica ' + self.idPratica
      );

      var tabs = self.propostaCartaDebitoIntSrvc.generaTabs(self.propostaCartaDebitoIntSrvc.datiPratica);

      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      // Costruzione tabs
      var tabData = null;
      var subtabData = null;
      for (var i = 0; i < tabs.length; i++) {
        tabData = tabs[i];
        subtabData = null;

        self.TAB_LIST_MACRO.push({
          index: i,
          step: tabData.step,
          title: tabData.posizione + ' ' + $scope.msg(tabData.label),
          url: self.getStepUrl(tabData.step),
          statoPratica: tabData.statoPratica
        });

        // Costruzione sotto-tabs, se presenti
        if (tabData.sottoStep && tabData.sottoStep.length > 0) {
          self.TAB_LIST_MICRO[tabData.step] = [];

          for (var j = 0; j < tabData.sottoStep.length; j++) {
            subtabData = tabData.sottoStep[j];

            self.TAB_LIST_MICRO[tabData.step].push({
              index: j,
              step: subtabData.step,
              title: tabData.posizione + '.' + subtabData.posizione + ' ' + $scope.msg(subtabData.label),
              url: self.getStepUrl(subtabData.step),
              statoPratica: subtabData.statoPratica
            });
          }
        }
      }

      self.attivaTabPerStatoPratica();
    };

    /**
     * Funzione richiamata in caso sia stato passato come parametro il solo id pratica
     * Recupera la pratica e mostra lo step corretto in base allo stato
     */
    this.recuperaPratica = function () {
      self.spinner.showSpinner++;
      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Recupero della pratica ' + self.idPratica
      );

      self.propostaCartaDebitoIntSrvc
        .promiseDettaglioPratica(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            // response.data.result.specializzazione = self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Recuperata con successo pratica ID ' + self.idPratica
            );

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            self.recuperaContoCorrente();

            // Controllo prodotto per Carta Debito Consumer
            self.propostaCartaDebitoIntSrvc.debitoConsumer = response.data.result.specializzazione;

            // Verifico se mi trovo sulla rotta con o senza NDG
            // Se non ho l'ndg, redirigo
            if (!self.$stateParams.ndg) {
              self.$state.go(
                'cdint-proposta-carta-debito-int-pratica-n',
                {
                  idPratica: self.idPratica,
                  ndg: self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
                },
                { reload: true }
              );
              return;
            } else {
              self.ndg = self.$stateParams.ndg;
            }

            self.recuperaTabs();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero della pratica ID ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione richiamata in caso siano stati passati come parametri id prodotto ed ndg
     * Avvia la creazione della pratica e, in caso di esito positivo, redirige alla rotta
     * con solo id pratica
     */
    this.prendiDettaglioProdotto = function () {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Dettaglio Prodotto ' + self.idProdotto
      );

      self.propostaCartaDebitoIntSrvc
        .promiseDettaglioProdotto(self.ndg, self.idProdotto)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;

            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.INFO,
              'Dettaglio prodotto con ID ' + self.idProdotto
            );

            // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
            self.recuperaTabs();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il dettaglio del prodotto ' +
                self.idProdotto +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione richiamata in caso siano stati passati come parametri id prodotto ed ndg
     * Avvia la creazione della pratica e, in caso di esito positivo, redirige alla rotta
     * con solo id pratica
     */
    this.creaPratica = function (prosegui, inviaDatiPG) {
      self.spinner.showSpinner++;

      self.loggerSrvc.log(
        'CdintPropostaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Creazione nuova pratica per NDG ' + self.ndg + ' e Prodotto ' + self.idProdotto
      );

      console.log('Pre chiamata crea pratica ' + self.propostaCartaDebitoIntSrvc.idTargetMarket);

      self.propostaCartaDebitoIntSrvc
        .promiseCreaPratica(
          self.ndg,
          self.idProdotto,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
            ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.codiceBusta
            : null,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.iban,
          self.propostaCartaDebitoIntSrvc.idTargetMarket ? self.propostaCartaDebitoIntSrvc.idTargetMarket : null,
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione ? self.propostaCartaDebitoIntSrvc.checkComma(self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via) : null,
          self.propostaCartaDebitoIntSrvc.datiDefinizioneSB && self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB.ndgUtilizzatore : null,
          inviaDatiPG
                  ? self.propostaCartaDebitoIntSrvc.datiDefinizioneSB
                  : self.propostaCartaDebitoIntSrvc.datiAggiuntivi
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

//            self.loggerSrvc.log(
//              'CdintPropostaCartaDebitoIntCtrl',
//              self.loggerSrvc.INFO,
//              'Creata con successo la pratica con ID ' + self.idPratica
//            );
//
//            if (
//              self.propostaCartaDebitoIntSrvc.datiAggiuntivi &&
//              !self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica
//            ) {
//              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.idPratica = self.idPratica;
//            }
//
//            self.confermaProdottoEsistente(prosegui, inviaDatiPG);
            
        	self.idPratica = response.data.result.idPratica;
            self.loggerSrvc.log(
	            'CdintPropostaCartaDebitoIntCtrl',
	            self.loggerSrvc.INFO,
	            'Conferma prodotto completata per la pratica ID ' + self.idPratica
	          );
	
	          self.propostaCartaDebitoIntSrvc.datiPratica = response.data.result;
	
	          if (prosegui) {
	            self.resetAbilitazioni();
	            self.attivaTabPerStatoPratica();
	          }
	          // Se tutto è andato a buon fine, ridirigo sulla rotta con id pratica
	          self.propostaCartaDebitoIntSrvc.isRedirecting = true;
	          self.$state.go(
	            'cdint-proposta-carta-debito-int-pratica',
	            {
	              idPratica: self.idPratica
	            },
	            { reload: true }
	          );
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la creazione della per NDG ' +
                self.ndg +
                ' e Prodotto ' +
                self.idProdotto +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione per prendere in carico la pratica
     */
    this.prendiInCarico = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promisePrendiInCarico(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
              return false;
            };
            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
              return true;
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la presa in carico della pratica  ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Funzione per rilasciare la pratica
     */
    this.rilasciaPratica = function () {
      //controllo se è un prospetto persona fisica di Banca Cloud
      self.spinner.showSpinner++;
      self.propostaCartaDebitoIntSrvc
        .promiseRilasciaPratica(self.idPratica)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
              return true;
            };
            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
              return false;
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'CdintPropostaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante la presa in carico della pratica  ' +
                self.idPratica +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      self.resetAbilitazioni();

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        /**
         * Caso 1: rotta con NDG, id Prodotto e id TargetMarket
         * Creo la pratica partendo da questi dati e redirigo alla rotta con solo di Pratica
         */
        if (self.$stateParams.ndg && self.$stateParams.idProdotto) {
          self.ndg = self.$stateParams.ndg;
          self.idProdotto = self.$stateParams.idProdotto;
          self.propostaCartaDebitoIntSrvc.idTargetMarket = !!self.$stateParams.idTargetMarket
            ? self.$stateParams.idTargetMarket
            : null;
          self.propostaCartaDebitoIntSrvc.ndg = self.ndg;
          self.propostaCartaDebitoIntSrvc.idProdotto = self.idProdotto;
          self.prendiDettaglioProdotto();

          console.log(
            'self.propostaCartaDebitoIntSrvc.idTargetMarket' + self.propostaCartaDebitoIntSrvc.idTargetMarket
          );
          return;
        }

        /**
         * Caso 2: rotta con solo ID Pratica, carico i dati della pratica e mostro
         * il passaggio in base allo stato della pratica stessa
         */
        if (self.$stateParams.idPratica) {
          self.idPratica = self.$stateParams.idPratica;
          self.recuperaPratica();
          return;
        }

        /**
         * Caso di nessun parametro passato
         */
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.parametersNotReceived')
        });
        self.loggerSrvc.log(
          'CdintPropostaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          $scope.msg('label.errors.parametersNotReceived')
        );
      });
    };

    self.init();
  };

  CdintPropostaCartaDebitoIntCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintPropostaCartaDebitoInt.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintPropostaCartaDebitoIntComponent = {
    controller: CdintPropostaCartaDebitoIntCtrl,
    controllerAs: 'cdintPropostaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.cartadebitoint.wa')
    .component('cdintPropostaCartaDebitoInt', CdintPropostaCartaDebitoIntComponent);
})();


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('CdintPropostaCartaDebitoIntSrvc', [
    '$http',
    'CdintUserSrvc',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, userSrvc, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      (this.userSrvc = userSrvc), (this.messaggiFctr = messaggiFctr);
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: 0 };

      /**
       * Dati della pratica, presenti anche nel componente cdintPropostaCartaDebitoInt
       */
      this.datiPratica;

      /**
       * ndg della richiesta
       */
      this.ndg;

      /**
       * Dati valorizzati per il primo step "cdintDefinizione" della specializzazione Small Business
       */
      this.datiDefinizioneSB;

      /**
       * Dati valorizzati per il secondo step "cdintDatiAggiuntivi" della specializzazione Light
       */
      this.datiAggiuntivi;

      /**
       * Dati valorizzati per il secondo step, primo sottostep "cdintDatiAggiuntiviPg"
       * della specializzazione small business (persona giuridica)
       */
      this.datiAggiuntiviPg;

      /**
       * Dati valorizzati per il secondo step, secondo sottostep "cdintDatiAggiuntiviPf"
       * della specializzazione small business (persona fisica)
       */
      this.datiAggiuntiviPf;

      /**
       * Dati valorizzati per il terzo step "cdintQuestionari"
       */
      this.questionari;

      /**
       * rappresenta il tipo Carta che è stato settato
       * per default è N per la light mentre per consumer e sb, preso da fe
       */
      this.currentTipoCarta;

      /**
       * Flag che indica se è in corso un redirect della pagina per visualizzare uno spinner speciale nell'intestazione
       */
      this.isRedirecting = false;

      /**
       * Riferimento interno
       */
      var self = this;

      /**
       * Utility di formattazione date
       */
      this.millisToDate = function (milliseconds) {
        var data = new Date(milliseconds);

        if (!data) {
          return null;
        }

        var day = data.getDate();
        var month = data.getMonth() + 1;
        var year = data.getFullYear();

        return (
          (day < 10 ? '0' + day.toString() : day.toString()) +
          '/' +
          (month < 10 ? '0' + month.toString() : month.toString()) +
          '/' +
          year.toString()
        );
      };

      /**
       * Utility per separare il numero civico dall'indirizzo
       */
      this.civicoDaIndirizzo = function (indirizzo) {
        if (!(indirizzo && indirizzo.trim().length > 0)) {
          return null;
        }

        // split per ' ' (spazio)
        var viaSplit = indirizzo.split(' ');
        var splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        // split per ','
        viaSplit = indirizzo.split(',');
        splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        return null;
      };

      /**
       * Indica se la pratica è in sola lettura
       */
      this.praticaIsReadOnly = function () {
        if (!self.datiPratica) {
          return true;
        }

        //EMonetica-437
        if (self.isCanaleBancaCloud()) {
          return true;
        }

        //QUID-138
        //Se il canale della pratica è promotore e il canale dello userProfile è filiale return true
        //console.log("Canale pratica " + self.datiPratica.canale + " Canale UP " + self.userSrvc.user.app)
        if (self.checkCanale(self.datiPratica.canale, self.userSrvc.user.app)) {
          if (
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.IN_CORSO ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.CONSOLIDATA ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.DAREVISIONARE
          ) {
            return true;
          }
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.RIFIUTATA:
            return true;
          default:
            return false;
        }
      };

      this.checkCanale = function (canalePratica, canaleUP) {
        return (
          canalePratica.toUpperCase() == CONSTANTS.CANALE.PROMOTORE &&
          canaleUP.toUpperCase() == CONSTANTS.CANALE.FILIALE
        );
      };

      this.isCanaleBancaCloud = function () {
        if (
          self.datiPratica.canale &&
          (self.datiPratica.stato == CONSTANTS.STATO_PRATICA.IN_CORSO ||
            self.datiPratica.stato == CONSTANTS.STATO_PRATICA.CONSOLIDATA)
        ) {
          return self.datiPratica.canale.toUpperCase() == CONSTANTS.CANALE.BANCACLOUD;
        }
      };

      /**
       * Funzione di default chiamata in caso di salva o prosegui per resettare l'indirizzo di spedizione.
       */
      this.copiaIndirizzoResidenzaInSpedizione = function () {
        // funzione sovrascritta da controller.
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione pulsante indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione prendi in carico. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultPrendiInCaricoVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione rilascia pratica. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRilasciaPraticaVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione proseguimento. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiAbilitato = function () {
        return false;
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "indietro" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di tornare indietro
       */
      this.indietroAbilitato = this.defaultIndietroAbilitato;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaVisibile = this.defaultSalvaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.proseguiVisibile = this.defaultProseguiVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prendi in carico" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di prendere in carico
       */
      this.prendiInCaricoVisibile = this.defaultPrendiInCaricoVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prendi in carico" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di prendere in carico
       */
      this.rilasciaPraticaVisibile = this.defaultRilasciaPraticaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "completa" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di completare
       */
      this.completaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        //QUID-138
        if (self.datiPratica.canale == 'BRIO_PROMOTORE' && self.userSrvc.user.app == 'filiale') {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
            return false;
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };

      this.rifiutaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
            return false;
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaAbilitato = this.defaultSalvaAbilitato;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.proseguiAbilitato = this.defaultProseguiAbilitato;

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Verifica se lo stato della pratica permette la navigazione tramite click sui tab
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        return self.praticaIsReadOnly();
      };

      /**
       * @ngdoc method
       * @name generaTabs
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Genera l'elenco delle tabs da visualizzare per la pratica
       * @return {Array} - Ritorna l'elenco delle tab disponibili per la pratica
       */
      this.generaTabs = function (datiPratica) {
        var tabs = [];

        tabs.push({
          step: 'DEFINIZIONE',
          label: 'label.tab.definizione',
          posizione: '1',
          statoPratica: [
            {
              stato: 'DAREVISIONARE',
              step: 1
            },
            {
              stato: 'INCORSO',
              step: 1
            }
          ],
          sottoStep: null
        });

        // Il tab dati aggiuntivi ha due sotto-step se la specializzazione è small business
        switch (datiPratica.specializzazione) {
          case CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS:
            tabs.push({
              step: 'DATIAGGIUNTIVI',
              label: 'label.tab.datiAggiuntivi',
              posizione: '2',
              statoPratica: null,
              sottoStep: [
                {
                  step: 'DATIAGGIUNTIVIPG',
                  label: 'label.tab.datiAggiuntivi.personagiuridica',
                  posizione: '1',
                  statoPratica: [
                    {
                      stato: 'INCORSO',
                      step: 2
                    }
                  ]
                },
                {
                  step: 'DATIAGGIUNTIVIPF',
                  label: 'label.tab.datiAggiuntivi.personafisica',
                  posizione: '2',
                  statoPratica: [
                    {
                      stato: 'INCORSO',
                      step: 3
                    }
                  ]
                }
              ]
            });

            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 4
                }
              ],
              sottoStep: null
            });
            break;
          case CONSTANTS.SPECIALIZZAZIONI.LIGHT:
            tabs.push({
              step: 'DATIAML',
              label: 'label.tab.datiAml',
              posizione: '2',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 2
                }
              ],
              sottoStep: null
            });
            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 3
                }
              ],
              sottoStep: null
            });
            break;
          default:
            tabs.push({
              step: 'DATIAGGIUNTIVI',
              label: 'label.tab.datiAggiuntivi',
              posizione: '2',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 2
                }
              ],
              sottoStep: null
            });

            tabs.push({
              step: 'QUESTIONARI',
              label: 'label.tab.questionari',
              posizione: '3',
              statoPratica: [
                {
                  stato: 'INCORSO',
                  step: 3
                }
              ],
              sottoStep: null
            });
            break;
        }

        tabs.push({
          step: 'DOCUMENTI',
          label: 'label.tab.documenti',
          posizione: '4',
          statoPratica: [
            {
              stato: 'CONSOLIDATA',
              step: 1
            },
            {
              stato: 'CONSOLIDATA',
              step: 2
            },
            {
              stato: 'CONSOLIDATA',
              step: 3
            },
            {
              stato: 'CONSOLIDATA',
              step: 4
            },
            {
              stato: 'CONSOLIDATA',
              step: 5
            },
            {
              stato: 'CONSOLIDATA',
              step: 6
            },
            {
              stato: 'PRESENTATA',
              step: 1
            },
            {
              stato: 'PRESENTATA',
              step: 2
            },
            {
              stato: 'PRESENTATA',
              step: 3
            }
          ],
          sottoStep: null
        });

        return tabs;
      };

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (ndg, idProdotto, codiceBusta, iban, idTargetMarket, via, ndgUtilizzatore, datiDefinizione) {
        
    	  var dati = {    			  
    	  }
    	  dati = datiDefinizione;
    	  dati.ndg =  ndg;
    	  dati.idProdotto = idProdotto;
    	  dati.codiceBusta = codiceBusta;
    	  dati.iban = iban;
    	  dati.idTargetMarket = idTargetMarket;
    	  dati.ndgUtilizzatore = ndgUtilizzatore;
    	  
    	  return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREA,
          data: dati
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioProdotto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseDettaglioProdotto = function (ndg, idProdotto) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CPT + ndg + '/' + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDatiConto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati del conto corrente
       * @return {Promise} - Ritorna una promise contenente i dati del conto corrente
       */
      this.promiseRecuperaDatiConto = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DATI_CONTO_CORRENTE + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrente
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i conti corrente legati all'ndg indicato
       * @return {Promise} - Ritorna una promise contenente l'elenco dei conti corrente collegati all'ndg
       */
      this.promiseRecuperaContiCorrente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICERCA.CONTICORRENTI + ndg + '/false'
          //                    ,
          //                    params: {
          //                        ndg: ndg
          //                    }
        });
      };
      
      this.promiseRicercaRapportiDelegati = function (ndg) {
          return this.$http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.RICERCA.RAPPORTI_DELEGATI + ndg 
          });
        };

      /**
       * @ngdoc method
       * @name promiseRicercaCliente
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per ricercare le anagrafiche cliente in base ai parametri specificati
       * @return {Promise} - Ritorna una promise contenente l'elenco delle anagrafiche trovate in base ai parametri
       */
      this.promiseRicercaCliente = function (ndg, intestazione) {
    	  
	   var isRicercaEstesa = false;
	   if(self.userSrvc.user.app == 'brio'){
		   if(self.userSrvc.abilitazioni){
			   angular.forEach(self.userSrvc.abilitazioni, function (abilitazione, index) {
				   if (abilitazione.codice == "RicercaClientiEstesa") {
					   isRicercaEstesa = true;
				   }
			   });
		   }
	   }else if(self.userSrvc.user.app == 'filiale'){
		   isRicercaEstesa = true;
	   }
          
        var queryParamsObj = {
          almenoUnrapporto: false,
          codiceFiscale: '',
          codiceIdentita: '',
          cognome: '',
          intestazione: '',
          ndg: '',
          nome: '',
          partitaIva: '',
          ricercaEstesa: isRicercaEstesa,
          sottorete: true
        };

        if (ndg) {
          queryParamsObj.ndg = ndg;
        } else if (intestazione) {
          queryParamsObj.intestazione = intestazione;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_CLIENTI_ROOT + CONSTANTS.REST.RICERCA.CLIENTI,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseDefinizioneProdotto
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma del prodotto
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDefinizioneProdotto = function (idPratica, idProdotto, datiDefinizione, prosegui) {
        var dati = {
          idPratica: idPratica,
          // Recupero dal service, ma per default è nominativa
          tipoCarta: self.datiAggiuntivi && self.datiAggiuntivi.tipoCarta ? self.datiAggiuntivi.tipoCarta : 'I1',
          idProdotto: idProdotto
        };

        if (datiDefinizione && self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.LIGHT) {
          // riprendo i dati
          dati = datiDefinizione;
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.idPratica = idPratica;
          dati.idProdotto = idProdotto;
        }
        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
          datiDefinizione.tipoCarta === 'I2'
        ) {
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = datiDefinizione.codiceBusta;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }
        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
          datiDefinizione.tipoCarta === 'I2'
        ) {
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = datiDefinizione.codiceBusta;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
          datiDefinizione.tipoCarta !== 'I2'
        ) {
          dati.ndgUtilizzatore = datiDefinizione.ndgUtilizzatore;
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = null;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        if (
          datiDefinizione &&
          self.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONI.CONSUMER &&
          datiDefinizione.tipoCarta !== 'I2'
        ) {
          dati.numeroRapporto = datiDefinizione.numeroRapporto;
          dati.iban = datiDefinizione.iban;
          dati.tipoCarta = datiDefinizione.tipoCarta;
          dati.codiceBusta = null;
          dati.idPraticaConto = datiDefinizione.idPraticaConto;
        }

        self.currentTipoCarta = dati.tipoCarta;

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DEF_PRODOTTO,
          data: dati,
          params: {
            prosegui: prosegui
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente l'oggetto anagrafica collegato alla pratica
       */
      this.promiseRecuperaAnagrafica = function (idPratica, recuperaUtilizzatore) {
        var queryParamsObj = {};

        if (recuperaUtilizzatore) {
          queryParamsObj.utilizzatore = recuperaUtilizzatore;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO + idPratica,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagraficaCoi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente la lista degli ndg anche delle COI
       */
      this.promiseRecuperaAnagraficaCoi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_COI + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDominiEntiRilascio
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati del dominio degli enti
       * @return {Promise} - Ritorna una promise contenente l'oggetto dominio degli enti di rilascio
       */
      this.promiseRecuperaDominiEntiRilascio = function (tipoDocumento, paeseEmissione) {
        var queryParamsObj = {};

        if (tipoDocumento) {
          queryParamsObj.tipoDocumento = tipoDocumento;
        }
        if (paeseEmissione) {
          queryParamsObj.paeseEmissione = paeseEmissione;
        }

        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOCUMENTO.ENTE_RILASCIO,
          params: queryParamsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente l'oggetto anagrafica collegato alla pratica
       */
      this.promiseRecuperaAnagraficaPic = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_ANA + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDatiAggiuntivi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO + ndg + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaTipoCarta
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaTipoCarta = function (idProdotto) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_CARTA + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaTipoCartaPerIdPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaProdottoPerIdPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_CARTA_PER_ID + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAml
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAml = function (idPratica, datiAml, prosegui) {
        var paramsObj = {
          prosegui: prosegui
        };

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AML,
          data: datiAml,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAggiuntivi = function (idPratica, datiAggiuntivi, prosegui, sottostep) {
        var paramsObj = {
          prosegui: prosegui
        };

        // aggiungo nei dati aggiuntivi anche il tipoCarta
        if (!datiAggiuntivi.tipoCarta) datiAggiuntivi.tipoCarta = self.currentTipoCarta;

        if (sottostep && sottostep > 0) {
          paramsObj.sottostep = sottostep;
        }

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI,
          data: datiAggiuntivi,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaQuestionariNexi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i questionari associati alla pratica
       * @return {Promise} - Ritorna una promise contenente l'elenco dei questionari, compilati o meno, per la pratica
       */
      this.promiseRecuperaQuestionariNexi = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.QUESTIONARI.NEXI + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseSaveQuestionari
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per salvare i questionari compilati dall'utente
       * @return {Promise} - Ritorna una promise contenente la conferma o meno del salvataggio
       */
      this.promiseSaveQuestionari = function (idPratica, questionari, prosegui) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.QUESTIONARI,
          data: {
            idPratica: idPratica,
            questionari: questionari
          },
          params: {
            prosegui: prosegui
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaConfigurazioneCampi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare la configurazione personalizzata dei campi per istituto
       * @return {Promise} - Ritorna una promise contenente la configurazione campi personalizzata
       */
      this.promiseRecuperaConfigurazioneCampi = function (nomeConfigurazione, ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.FIELDCONFIGURATOR + nomeConfigurazione + '/' + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseCompletaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.COMPLETA,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseProspettoPersonaFisica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseProspettoPersonaFisica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.PROSPETTOPERSONAFISICA + idPratica,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseAccettazionePratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseAccettazionePratica = function (datiProspetto) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_PROSPECTMANAGER_ROOT + CONSTANTS.REST.ACCETTAZIONE,
          data: {
            idPratica: datiProspetto.idProspetto,
            nota: datiProspetto.nota
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare l'annullamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseAnnullaPratica = function (idPratica, note) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.ANNULLA,
          data: note
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il rifiuto della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseRifiutaPratica = function (idPratica, note) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.RIFIUTA,
          data: note
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioContoCorrente = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CONTOCORRENTE.replace('{idPratica}', idPratica)
        });
      };

      /**
       * @ngdoc funzione di utility per scorporo civico da indirizzo
       * @name promiseAnnullaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare l'annullamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.getStreetNumber = function (address) {
        var r = /\d+/;

        var regex = address.match(r);
        if (regex && Array.isArray(regex) && regex.length)
          return {
            indirizzo: address.substring(0, regex.index),
            civico: address.substring(regex.index, address.length)
          };
        else return null;
      };

      this.checkComma = function (via){
    	if(!via){
    		return null;
    	}
    	via = via.trim();
      	if (via.endsWith(',')) {
      		return self.checkComma(via.slice(0, -1));
  		}
  		return via;
      }
      
      /**
       * @ngdoc method
       * @name promiseVerificaPresaInCarico
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per verificare se la pratica è gia' presa in carico
       * @return {Promise} - Ritorna una promise contenente true/false
       */
      this.promiseVerificaPresaInCarico = function (idPratica) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO +
            idPratica +
            CONSTANTS.REST.PRATICA.VERIFICAPRESAINCARICO,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promisePrendiInCarico
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per prendere in carico la pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promisePrendiInCarico = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.PRENDIINCARICO,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRilasciaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua la chiamata per rilasciare la pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseRilasciaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.RILASCIAPRATICA,
          data: {
            idPratica: idPratica
          }
        });
      };

      this.promiseCheckIbanAndConfermaProdotto = function (iban) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.VERIFICA_CONTO_LIGHT,
          data: iban
        });
      };
    }
  ]);
})();


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintQuestionari
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintQuestionariCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Copia dei dati pratica contenenti i questionari
     */
    this.datiPratica = null;

    /**
     * Impostazioni datepicker
     */
    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    /**
     * Configurazione campi widget trasparenza
     */
    this.transparencyFieldsConfig = {};

    /**
     * Configurazione campi widget kyc
     */
    this.kycFieldsConfig = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.questionariValidi();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.questionariValidi();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };
    
    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    this.questionariValidi = function () {
      // if (
      //   self.datiPratica.specializzazione ===
      //     self.CONSTANTS.SPECIALIZZAZIONI.LIGHT &&
      //   !(
      //     self.propostaCartaDebitoIntSrvc.questionari &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .scopoApertura &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .destinazioneInvestimentoProvincia &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .destinazioneInvestimentoNazione
      //   )
      // ) {
      //   return false;
      // }

      // Controllo questionari
      if (
        self.datiPratica.specializzazione !== self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
        !(
          self.propostaCartaDebitoIntSrvc.questionari &&
          self.propostaCartaDebitoIntSrvc.questionari.privacyNexi &&
          self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande
        )
      ) {
        return false;
      }

      var enabled = true;

      for (var i = 0; i < self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande.length; i++) {
        var domanda = self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande[i];
        if (domanda.valore === null || domanda.valore === undefined) {
          enabled = false;
        }
      }

      return enabled;
    };

    /**
     * Funzione che avvia il recupero della configurazione campi personalizzata per banca e il questionario privacy nexi
     */
    this.recuperaConfigurazioneCampi = function () {
      self.spinner.showSpinner++;

      var configurazioni = [
        self.propostaCartaDebitoIntSrvc.promiseRecuperaQuestionariNexi(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
        )
      ];

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione !== self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS
      ) {
        configurazioni.push(
          self.propostaCartaDebitoIntSrvc.promiseRecuperaConfigurazioneCampi(
            'QUESTIONARIO_KYC_RAPPORTO',
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        );
        configurazioni.push(
          self.propostaCartaDebitoIntSrvc.promiseRecuperaConfigurazioneCampi(
            'QUESTIONARIO_TRASPARENZA',
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        );
      }

      $q.all(configurazioni)
        .then(function (responses) {
          self.propostaCartaDebitoIntSrvc.questionari = {};

          // PRIVACY NEXI
          if (responses[0] && !self.messaggiFctr.processaResponse(responses[0])) {
            self.propostaCartaDebitoIntSrvc.questionari.privacyNexi = responses[0].data.result;
          }

          // KYC
          if (responses[1] && !self.messaggiFctr.processaResponse(responses[1])) {
            var kycConfig = {};
            for (var prop in responses[1].data.result) {
              if (Object.prototype.hasOwnProperty.call(responses[1].data.result, prop)) {
                kycConfig['questionarioKycRapporto.' + prop] = responses[1].data.result[prop];
              }
            }

            self.kycFieldsConfig = kycConfig;

            const rapportoKyc = !!self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              ? self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              : {};

            self.propostaCartaDebitoIntSrvc.questionari.kycRapporto = rapportoKyc.questionarioKycRapporto;
          }

          // TRASPARENZA
          if (responses[2] && !self.messaggiFctr.processaResponse(responses[2])) {
            self.transparencyFieldsConfig = responses[2].data.result;

            const rapportoTrasparenza = !!self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              ? self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              : {};

            self.propostaCartaDebitoIntSrvc.questionari.trasparenza = {
              codiceClassificazione: rapportoTrasparenza.codiceClassificazione
            };
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // Copio i dati pratica e forzo la creazione del campo naturaGiuridica sull'intestatario
        // per compatibilità con gli widget
        self.datiPratica = JSON.parse(JSON.stringify(self.propostaCartaDebitoIntSrvc.datiPratica));
        self.datiPratica.intestatario.naturaGiuridica = self.datiPratica.intestatario.formaCostitutiva;

        self.recuperaConfigurazioneCampi();
      });
    };

    self.init();
  };

  CdintQuestionariCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintQuestionari/cdintQuestionari.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintQuestionariComponent = {
    controller: CdintQuestionariCtrl,
    controllerAs: 'cdintQuestionariCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintQuestionari', CdintQuestionariComponent);
})();


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintSpedizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintSpedizioneCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    this.domainSrvc = domainSrvc;

    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([
        self.domainSrvc.promiseDomain('NAZIONE'),
        self.domainSrvc.promiseDomain('PROVINCIA'),
        self.domainSrvc.promiseDomain('TAE'),
        self.propostaCartaDebitoIntSrvc.promiseRecuperaDominiEntiRilascio(
          self.datiAnagrafici.documentoIdentificativo.tipoDocumento.descrizione,
          self.datiAnagrafici.documentoIdentificativo.nazioneDocumento.codice
        )
      ])
        .then(function (responses) {
          self.paesi = responses[0];
          // Se la nazionalità del doc id è italia allora rimuovo stato estero, altrimenti obbligo la sua scelta
          if (self.datiAnagrafici.datiAggiuntivi.indirizzoSpedizione.nazione.codice === '086') {
            self.province = responses[1];
            self.province = self.province.filter(function (value) {
              return value.codice !== '**';
            });
          } else {
            self.province = [{ codice: '**', descrizione: 'STATO ESTERO' }];
          }
          self.tae = responses[2];
          self.entiRilascio = responses[3].data ? responses[3].data.result.elenco : [];

          self.cdintDefinizioneCtrl.recuperaComuni(false, false);

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap ||
            (self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
              self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore)
          ) {
            self.recuperaCAP();
          }

          if (
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita ||
            self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // fix CDICDDI-171 (indirizzo nazione spedizione == italia --> Forzato)
          self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.propostaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.recuperaDomini();
      });
    };
    self.init();
  };

  CdintSpedizioneCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintSpedizione/cdintSpedizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintSpedizioneComponent = {
    controller: CdintSpedizioneCtrl,
    controllerAs: 'cdintSpedizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintSpedizione', CdintSpedizioneComponent);
})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:inquiryLottCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di richiesta lotto
 */
(function () {
  'use strict';
  var InquiryLottCartaDebitoIntCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $filter,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    inquiryLottCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.inquiryLottCtrl = this;

    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.domainSrvc = domainSrvc;
    this.inquiryLottCartaDebitoIntSrvc = inquiryLottCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Altezza della griglia carte
     */
    this.altezzaTabellaLottoCarte = 0;
    this.altezzaTabellaDettaglio = 0;
    
    /**
     * Altezza di una riga della griglia dei carte
     */
    this.altezzaRigaCarte = 30;
    
    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.inquiryLottCartaDebitoIntSrvc.spinner;

    /**
     * Inizializzazione lista lotti
     */
    this.listaLotti = null;
    
    this.lottoSelezionato = [];
    
    this.showDettaglio = false;
    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    this.cerca = function () {
    	self.spinner.showSpinner = true;
    	self.listaLotti = null;
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa.setHours('00');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa.setMinutes('00');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataA.setHours('23');
    	self.inquiryLottCartaDebitoIntSrvc.filtro.dataA.setMinutes('59');
          $q.all([
            self.inquiryLottCartaDebitoIntSrvc.promiseCerca(self.inquiryLottCartaDebitoIntSrvc.filtro),
          ]).then(
            function (response) {
              self.listaLotti = response[0].data.result;
              if(self.listaLotti && self.listaLotti.length>0){
            	
            	angular.forEach(self.listaLotti, function (lotto, index) {
                  lotto.prodotto = self.getDescrizioneProdotto(lotto.prodotto,  self.inquiryLottCartaDebitoIntSrvc.elencoProdotto);
                  lotto.stato = self.getDescrizioneStato(lotto.stato,  self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto);
                });
            	  self.loadElencoCarteGrid(self.listaLotti);
              }
              self.spinner.showSpinner = false;
            },
            function (reason) {
              console.error(reason);
              self.spinner.showSpinner = false;
            });
    };

    this.getDescrizioneStato = function (codice, elenco){
    	var risultato;
    	
    	angular.forEach(elenco, function (elemento, index) {
            if(elemento.codice == codice){
            	risultato = elemento.descrizione;
            }
          });
    	return risultato;
    };
    
    this.getDescrizioneProdotto = function (codice, elenco){
    	var risultato;
    	
    	angular.forEach(elenco, function (elemento, index) {
            if(elemento.codiceProdotto == codice){
            	risultato = elemento.descrizioneProdotto;
            }
          });
    	return risultato;
    };
    
    this.loadElencoCarteGrid = function (arrayCurrentCarta) {
        
    	self.altezzaTabellaLottoCarte = arrayCurrentCarta.length * self.altezzaRigaCarte + 40;

        self.lottoCarteGridOptions = {
          enableSorting: true,
          enableColumnMenus: false,
          enableGrouping: false,
          multiSelect: false,
          showHeader: true,
          enableRowHeaderSelection: false,
          enableRowSelection: false,
          showGridFooter: false,
          enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
          enableColumnResizing: true,
          columnDefs: [
            {
              displayName: $scope.msg('label.tab.inquirylott.dataInserimento'),
              field: 'dataInserimentoRichiesta',
              width: '15%',
              name: 'dataInserimentoRichiesta',
              cellFilter: 'date:\'dd-MM-yyyy\'',
              sort: {
                  direction: uiGridConstants.DESC,
                  priority: 0,
                }
            },
            {
              displayName: $scope.msg('label.tab.inquirylott.prodotto'),
              field: 'prodotto',
              width: '35%',
              name: 'prodotto'
            },
            {
              displayName: $scope.msg('label.tab.inquirylott.stato'),
              field: 'stato',
              width: '30%',
              name: 'stato'
            },
            {
                displayName: $scope.msg('label.tab.inquirylott.numero'),
                field: 'numero',
                width: '10%',
                name: 'numero'
              },
            {
              displayName: "Dettaglio",
              field: '',
              width: '10%',
              name: ' ',
              cellTemplate :'<div class="text-center"><button class="btn btn-primary"     style="padding: 2px 6px;" data-toggle="modal"  ng-click="grid.appScope.inquiryLottCtrl.apriDettaglio(row.entity)">Dettaglio</button></div>'
            }
          ],
          data: arrayCurrentCarta
        };
      };

      this.loadDettaglioGrid = function (row) {
          
      	self.altezzaTabellaDettaglio = self.altezzaRigaCarte + 40;

          self.dettaglioGridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: false,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: $scope.msg('label.tab.inquirylott.utente'),
                field: 'utente',
                width: '30%',
                name: 'utente'
              },
              {
                displayName: $scope.msg('label.tab.inquirylott.posizione'),
                field: 'codicePosizioneIniziale',
                width: '30%',
                name: 'codicePosizioneIniziale'
              },
              {
                displayName: $scope.msg('label.tab.inquirylott.indirizzoSpedizione'),
                field: 'indirizzoSpedizione',
                width: '40%',
                name: 'indirizzoSpedizione'
              }
            ],
            data: row
          };
        };

      
      this.apriDettaglio = function (lotto) {
      		self.lottoSelezionato.push(lotto);
      		self.loadDettaglioGrid(self.lottoSelezionato);
      		self.showDettaglio = true;
      };
      
      this.indietro = function () {
    	  self.lottoSelezionato = [];
    		self.showDettaglio = false;
    };


    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      var d = new Date(Date.now());
      self.inquiryLottCartaDebitoIntSrvc.filtro.dataDa = new Date(d.setMonth(d.getMonth()-1 , d.getDate()));
      
      labelSrvc.labelsPronte.then(function () {
          self.labelsPronte = true;

          // recupero delle carte per il codice prodotto
          self.spinner.showSpinner = true;
          $q.all([
            self.inquiryLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
            self.inquiryLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.STATI_LOTTI)
          ]).then(
            function (response) {
              self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto = response[1].data.result;
              self.inquiryLottCartaDebitoIntSrvc.elencoStatiLottoFiltro = $filter('filter')(self.inquiryLottCartaDebitoIntSrvc.elencoStatiLotto, {visibile : "1"});
              self.inquiryLottCartaDebitoIntSrvc.elencoProdotto = response[0].data.result;
              self.spinner.showSpinner = false;
            },
            function (reason) {
              console.error(reason);
              self.spinner.showSpinner = false;
            }
          );
        });
      
    };

    self.init();
  };


  InquiryLottCartaDebitoIntCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$filter',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'InquiryLottCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'inquiryLottCartaDebitoInt/inquiryLottCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var InquiryLottCartaDebitoIntComponent = {
    controller: InquiryLottCartaDebitoIntCtrl,
    controllerAs: 'inquiryLottCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('inquiryLottCartaDebitoInt', InquiryLottCartaDebitoIntComponent);
})();


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:inquiryLottCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di inquiry lotto richiesta carte
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('InquiryLottCartaDebitoIntSrvc', [
    '$http',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * numero delle carte richiesto per la richiesta
       */
      this.currentNumeroCarte;

      /**
       * prodotto selezionato.
       */
      this.currentProdotto;

      /**
       * elenco dei prodotti.
       */
      this.elencoProdotto;

      /**
       * elenco degli stati lotto.
       */
      this.elencoStatiLotto;
      
      /**
       * elenco degli stati lotto visibile nel filtro.
       */
      this.elencoStatiLottoFiltro;
      
      /**
       * indirizzo spedizione.
       */
      this.currentIndirizzoSpedizione;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: false };

      /**
       * Riferimento interno
       */
      var self = this;

      this.resetData = function () {
        self.currentNumeroCarte = null;
        self.currentProdotto = null;
      };
      
      /**
       * 
       * Inizializzazione del filtro ricerca
       */    
      this.filtro = {
    		'dataDa' : new Date(),
      		'dataA' : new Date(),
      		'prodotto' : null,
      		'stato' : null
      };
      
      this.resetFiltro = function () {
    	  var d = new Date(Date.now());
          
    		  self.filtro = {
    		    		'dataDa' : new Date(d.setMonth(d.getMonth()-1 , d.getDate())),
    		      		'dataA' : new Date(),
    		      		'prodotto' : null,
    		      		'stato' : null
    		      };
      }

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione del pulsante "richiedi". Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediAbilitato = function () {
        return false;
      };

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.richiediVisibile = this.defaultRichiediVisibile;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.richiediAbilitato = this.defaultRichiediAbilitato;


      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:ReqLottCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDominio = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseCerca
       * @methodOf cbl.cartadebitoint.wa.directive:InquiryLottCartaDebitoIntSrvc
       * @description Effettua la chiamata per cercare i lotti carte 
       * @return {Promise} - Ritorna una promise contenente la lista dei lotti
       */
      this.promiseCerca = function (filtro) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.REQ_LOTT.CERCA_LOTTI,              
          data: filtro
        });
      };
    }
  ]);
})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaCartaDebitoIntCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    postVenditaCartaDebitoIntSrvc,
    domainSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.domainSrvc = domainSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;
    

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * Parametri passati dalla rotta ndg + id prodotto
     * Necessari per la creazione della pratica
     */
    this.ndg;

    /**
     * Tabs di primo livello
     */
    this.TAB_LIST_MACRO = [];

    /**
     * Tabs di secondo livello
     */
    this.TAB_LIST_MICRO = {};

    /**
     * Tab attivo
     */
    this.currentTabMacro = {};

    /**
     * Sottotab attivo
     */
    this.currentTabMicro = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     * Navigazione verso lo step precedente
     */
    this.annulla = function () {
      self.messaggiFctr.resetMessages();

      if (self.postVenditaCartaDebitoIntSrvc.idPratica) {
        self.spinner.showSpinner++;
        self.postVenditaCartaDebitoIntSrvc
          .promiseAnnullaPostVendita(self.postVenditaCartaDebitoIntSrvc.idPratica)
          .then(function (resp) {
            if (self.messaggiFctr.processaResponse(resp)) {
              return;
            }

            self.$state.go('schedaCliente', { ndg: self.ndg });
          })
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      } else {
        self.$state.go('schedaCliente', { ndg: self.ndg });
      }
    };
    /**
     * Richiamato nelle funzioni salva e prosegui, lancia la chiamata abbinata allo stato e step pratica
     * e, se specificato, applica il flag per il solo salvataggio
     */
    this.eseguiSalvataggioStep = function (prosegui) {
      var stato = null;
      var step = null;

      // Recupero la prima combinazione, poiché la chiamate per completare ogni tab sono le solite
      if (self.currentTabMicro) {
        stato = self.currentTabMicro.statoPratica[0].stato;
        step = self.currentTabMicro.statoPratica[0].step;
      } else {
        stato = self.currentTabMacro.statoPratica[0].stato;
        step = self.currentTabMacro.statoPratica[0].step;
      }

      // devo switchare in base al codice funzione
      switch (stato) {
        case CONSTANTS.STATO_PRATICA.IN_CORSO:
        case CONSTANTS.STATO_PRATICA.DAREVISIONARE:
          // A seconda della specializzazione le chiamate da eseguire sono diverse
          switch (self.postVenditaCartaDebitoIntSrvc.currentFunzione) {
            case CONSTANTS.FUNZIONI.ATTIVA_BLOCCO:
            case CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO:
            case CONSTANTS.FUNZIONI.MOD_INTESTA:
            case CONSTANTS.FUNZIONI.MOD_CONDIZIONI:
            case CONSTANTS.FUNZIONI.MOD_LIMITI:
            case CONSTANTS.FUNZIONI.MOD_CONTO:
            case CONSTANTS.FUNZIONI.MOD_INDIRIZZO:
              switch (step) {
                case 1:
                  self.avanzaPratica(prosegui, true);
                  break;
              }
              break;
            // sono tutti riconducibili alla stessa funzione.
            case CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO:
            case CONSTANTS.FUNZIONI.DUP_CARTA:
            case CONSTANTS.FUNZIONI.RIF_CARTA:
              switch (step) {
                case 1:
                  self.rimuovi_blocco(prosegui, self.postVenditaCartaDebitoIntSrvc.currentFunzione, true);
                  break;
              }
              break;
          }
          break;
      }
    };

    /**
     * Salvataggio dello stato della pratica
     */
    this.salva = function () {
      self.messaggiFctr.resetMessages();

      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Salvataggio della pratica ID ' +
          self.postVenditaCartaDebitoIntSrvc.idPratica +
          ': stato attuale ' +
          self.postVenditaCartaDebitoIntSrvc.datiPratica.stato
      );

      self.eseguiSalvataggioStep(false);
    };

    /**
     * Proseguimento allo step successivo della pratica
     * O, se ci troviamo all'ultimo step, completamento
     */
    this.avanza = function () {
      self.messaggiFctr.resetMessages();

      if (
        self.postVenditaCartaDebitoIntSrvc.currentCarta &&
        (self.postVenditaCartaDebitoIntSrvc.currentCarta.stato === 'EL' ||
          (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO &&
            self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight))
      ) {
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.cartaNonAmmessa')
        });
        return;
      }

      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Avanzamento di step per ndg ' +
          self.ndg +
          ': funzione ' +
          self.postVenditaCartaDebitoIntSrvc.currentFunzione +
          ': carta selezionata ' +
          self.postVenditaCartaDebitoIntSrvc.currentCarta
      );

      self.eseguiSalvataggioStep(true);
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.rimuovi_blocco = function (prosegui, funzione, inviaDatiPG) {
      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'Conferma rimuovi blocco carta ' + self.postVenditaCartaDebitoIntSrvc.currentCarta
      );

      self.spinner.showSpinner++;

      if (prosegui) {
        self.resetAbilitazioni();
        self.attivaTabPerStatoPratica();
      }

      if (self.spinner.showSpinner > 0) {
        self.spinner.showSpinner--;
      }

      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 2
      };
    };

    /**
     * Function applicata al click su indietro. Essendo 2 tab riporto lo stato a step 1 indipendentemente da dove mi trovo
     */
    this.indietro = function () {
      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 1
      };
      self.currentTabMacro = self.TAB_LIST_MACRO[0];
      self.currentTabMicro = self.TAB_LIST_MICRO[0];
    };

    /**
     * Funzione eseguita dal prosegui del primo step, conferma il prodotto abbinato alla pratica
     */
    this.avanzaPratica = function (prosegui) {
      self.loggerSrvc.log(
        'PostVenditaCartaDebitoIntCtrl',
        self.loggerSrvc.INFO,
        'avanzamento pratica ' +
          self.postVenditaCartaDebitoIntSrvc.currentCarta +
          'funzione ' +
          self.postVenditaCartaDebitoIntSrvc.currentFunzione
      );

      self.spinner.showSpinner++;

      self.postVenditaCartaDebitoIntSrvc.datiPratica = {
        stato: 'INCORSO',
        step: 2
      };
      if (prosegui) {
        self.resetAbilitazioni();
        self.attivaTabPerStatoPratica();
      }

      if (self.spinner.showSpinner > 0) {
        self.spinner.showSpinner--;
      }
    };

    /**
     * Funzione che verifica se il tab specificato è abilitato per lo stato/step indicati
     * Step può essere null, in quel caso sarà verificato solo lo stato
     */
    this.tabContieneStatoStep = function (tab, stati, step) {
      if (!(tab && tab.statoPratica)) {
        return false;
      }

      if (!(stati && stati.length > 0)) {
        return false;
      }

      for (var i = 0; i < tab.statoPratica.length; i++) {
        if (stati.indexOf(tab.statoPratica[i].stato) > -1 && (!step || tab.statoPratica[i].step === step)) {
          return true;
        }
      }

      return false;
    };

    this.completaPratica = function () {
      // recupero i dati in base allo step e alla funzione e creo la pratica.ab-last-read
      self.spinner.showSpinner++;

      //QUID-27 richiesto controllo su tipologia Light del cc, al momento non implementabile per mancanza informazione
      //      if(self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
      //    		  && self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight){
      //    	  self.messaggiFctr.addMessage({
      //              type: 'E',
      //              message: $scope.msg('label.errors.cartaNonAmmessa')
      //            });
      //    	  if (self.spinner.showSpinner > 0) {
      //              self.spinner.showSpinner--;
      //            }
      //    	  return;
      //      }
      if(self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO){
    	  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via.toUpperCase();
    	  if(self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso){
    		  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso.toUpperCase();
    		  self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.presso.replace('C/O ', ' ').replace(' C/O ', ' ').replace(' CO ', ' ');
    	  }
      }

      return self.postVenditaCartaDebitoIntSrvc
        .promiseCreaPratica(
          self.postVenditaCartaDebitoIntSrvc.ndg,
          self.postVenditaCartaDebitoIntSrvc.currentCarta.numeroCarta,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione,
          // verifico in base a funzione
          // MDOCONTO
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
            ? self.postVenditaCartaDebitoIntSrvc.currentConto.iban
            : null,
          // NUOVA INTESTAZIONE
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INTESTA
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.nuovaIntestazione
            : null,
          // ATTIVA BLOCCO
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO
            ? self.postVenditaCartaDebitoIntSrvc.currentBlocco
            : null,
          // MODIFICA CONDIZIONI
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.importoQuota
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.condizione
            : null,
          // MODIFICA LIMITI
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteGiornaliero
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteMensile
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteDownoption
            : null,
          self.postVenditaCartaDebitoIntSrvc.idPratica,
          self.postVenditaCartaDebitoIntSrvc.currentCarta.cartalight,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO
            ? self.postVenditaCartaDebitoIntSrvc.currentConto.numeroRapporto
            : null,
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO
            ? self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione
            : null
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.$state.go('schedaCliente', { ndg: self.ndg });
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Reimposta le funzioni di abilitazione e visualizzazione dei pulsanti a pié di pagina
     */
    this.resetAbilitazioni = function () {
      self.postVenditaCartaDebitoIntSrvc.indietroAbilitato =
        self.postVenditaCartaDebitoIntSrvc.defaultIndietroAbilitato;
      self.postVenditaCartaDebitoIntSrvc.salvaVisibile = self.postVenditaCartaDebitoIntSrvc.defaultSalvaVisibile;
      self.postVenditaCartaDebitoIntSrvc.salvaAbilitato = self.postVenditaCartaDebitoIntSrvc.defaultSalvaAbilitato;
      self.postVenditaCartaDebitoIntSrvc.proseguiAbilitato =
        self.postVenditaCartaDebitoIntSrvc.defaultProseguiAbilitato;
    };

    this.resetDatiPratica = function () {
      self.postVenditaCartaDebitoIntSrvc.datiPratica = null;
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (!self.postVenditaCartaDebitoIntSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Verifico se il tab ha sotto-tab
      if (self.TAB_LIST_MICRO[self.currentTabMacro.step] && self.TAB_LIST_MICRO[self.currentTabMacro.step].length > 0) {
        self.currentTabMicro = self.TAB_LIST_MICRO[self.currentTabMacro.step][0];
      } else {
        self.currentTabMicro = null;
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.cartadebitoint.wa.directive:cdintPropostaCartaDebitoInt
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < self.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === self.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /**
     * In base allo step definito nel tab, recupera l'URL del template da visualizzare
     */
    this.getStepUrl = function (step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'DATIAGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        default:
          return null;
      }
    };

    /**
     * Funzione che dopo il recupero dei tab o dopo un cambio stato evidenzia il tab attivo
     * in base allo stato della pratica
     */
    this.attivaTabPerStatoPratica = function () {
      if (self.postVenditaCartaDebitoIntSrvc.datiPratica) {
        if (
          self.postVenditaCartaDebitoIntSrvc.datiPratica &&
          self.postVenditaCartaDebitoIntSrvc.datiPratica.stato &&
          self.postVenditaCartaDebitoIntSrvc.datiPratica.step
        ) {
          // Se la pratica è in stato di ACCETTATA apro direttamente
          // la prima tab e primo step visto che il wizard è navigabile
          if (self.postVenditaCartaDebitoIntSrvc.datiPratica.stato === CONSTANTS.STATO_PRATICA.ACCETTATA) {
            self.currentTabMacro = self.TAB_LIST_MACRO[0];
            self.currentTabMicro = self.TAB_LIST_MICRO[0];
            return;
          }

          // Nel caso di pratica consolidata devo valutare solamente lo stato
          // Negli altri casi tutto il resto
          for (var i = 0; i < self.TAB_LIST_MACRO.length; i++) {
            var macroTab = self.TAB_LIST_MACRO[i];
            // Verifico se ho dei sotto-tab
            // In caso positivo imposto sia il macro-tab che il micro-tab
            if (!macroTab.statoPratica && self.TAB_LIST_MICRO[macroTab.step]) {
              for (var j = 0; j < self.TAB_LIST_MICRO[macroTab.step].length; j++) {
                var microTab = self.TAB_LIST_MICRO[macroTab.step][j];
                if (
                  self.tabContieneStatoStep(
                    microTab,
                    [self.postVenditaCartaDebitoIntSrvc.datiPratica.stato],
                    self.postVenditaCartaDebitoIntSrvc.datiPratica.step
                  )
                ) {
                  self.currentTabMacro = macroTab;
                  self.currentTabMicro = microTab;

                  self.loggerSrvc.log(
                    'PostVenditaCartaDebitoIntCtrl',
                    self.loggerSrvc.INFO,
                    'Apertura tab ' +
                      self.currentTabMacro.title +
                      '/' +
                      self.currentTabMicro.title +
                      ' per pratica ID ' +
                      self.postVenditaCartaDebitoIntSrvc.idPratica
                  );
                  return;
                }
              }

              continue;
            }

            // Altrimenti solo il macro-tab
            if (
              self.tabContieneStatoStep(
                macroTab,
                [self.postVenditaCartaDebitoIntSrvc.datiPratica.stato],
                self.postVenditaCartaDebitoIntSrvc.datiPratica.step
              )
            ) {
              self.currentTabMacro = macroTab;
              self.currentTabMicro = null;

              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.INFO,
                'Apertura tab ' +
                  self.currentTabMacro.title +
                  ' per pratica ID ' +
                  self.postVenditaCartaDebitoIntSrvc.idPratica
              );

              return;
            }
          }
        }

        self.currentTabMacro = self.TAB_LIST_MACRO[0];
      }
      // attivo il tab iniziale
      if (!!self.currentTabMacro) {
        self.currentTabMacro = self.TAB_LIST_MACRO[0];
        self.currentTabMicro = null;
      }
    };

    /**
     * Funzione richiamata dopo il caricamento della pratica, recupera le tabs disponibili
     */
    this.recuperaTabs = function () {
      // Genera le tab passando un boolean che indica se c'è una seconda tab o no
      // Per il momento la seconda tab c'è solo se la funzione selezionata è blocco o cambio conto
      var tabs = self.postVenditaCartaDebitoIntSrvc.generaTabs(
        !self.postVenditaCartaDebitoIntSrvc.currentFunzione ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'APLBLC' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODCNT' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODIND'
      );

      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      // Costruzione tabs
      var tabData = null;
      var subtabData = null;
      for (var i = 0; i < tabs.length; i++) {
        tabData = tabs[i];
        subtabData = null;

        self.TAB_LIST_MACRO.push({
          index: i,
          step: tabData.step,
          title: tabData.posizione + ' ' + $scope.msg(tabData.label),
          url: self.getStepUrl(tabData.step),
          statoPratica: tabData.statoPratica
        });

        // Costruzione sotto-tabs, se presenti
        if (tabData.sottoStep && tabData.sottoStep.length > 0) {
          self.TAB_LIST_MICRO[tabData.step] = [];

          for (var j = 0; j < tabData.sottoStep.length; j++) {
            subtabData = tabData.sottoStep[j];

            self.TAB_LIST_MICRO[tabData.step].push({
              index: j,
              step: subtabData.step,
              title: tabData.posizione + '.' + subtabData.posizione + ' ' + $scope.msg(subtabData.label),
              url: self.getStepUrl(subtabData.step),
              statoPratica: subtabData.statoPratica
            });
          }
        }
      }
      self.attivaTabPerStatoPratica();
    };

    // Al cambio di funzione (segnalato con emit) si cambia le tab
    $scope.$on('onFunzioneChange', function () {
      self.recuperaTabs();
    });

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      self.resetAbilitazioni();

      self.resetDatiPratica();

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.postVenditaCartaDebitoIntSrvc.resetData();
        /**
         * rotta con solo ndg non c'e' un wf della pratica.
         */
        if (self.$stateParams.ndg) {
          self.ndg = self.$stateParams.ndg;
          self.postVenditaCartaDebitoIntSrvc.ndg = self.ndg;

          // Recupero le tab all'init
          self.recuperaTabs();
          return;
        }

        /**
         * Caso di nessun parametro passato
         */
        self.messaggiFctr.addMessage({
          type: 'E',
          message: $scope.msg('label.errors.parametersNotReceived')
        });
        self.loggerSrvc.log(
          'PostVenditaCartaDebitoIntCtrl',
          self.loggerSrvc.SEVERE,
          $scope.msg('label.errors.parametersNotReceived')
        );
      });
    };

    self.init();
  };

  PostVenditaCartaDebitoIntCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'postVenditaCartaDebitoInt/postVenditaCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaCartaDebitoIntComponent = {
    controller: PostVenditaCartaDebitoIntCtrl,
    controllerAs: 'postVenditaCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaCartaDebitoInt', PostVenditaCartaDebitoIntComponent);
})();


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:postVenditaCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('PostVenditaCartaDebitoIntSrvc', [
    '$http',
    '$q',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, $q, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.$q = $q;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: 0 };

      /**
       * Dati della pratica, presenti anche nel componente cdintPropostaCartaDebitoInt
       */
      this.datiPratica;

      /**
       * elenco delle carte recuperate dall'MF per ndg.
       */
      this.elencoCarte;

      /**
       * anagrafica di riferimento
       */
      this.anagrafica;

      /**
       * elenco delle funzioni
       */
      this.elencoFunzioni;

      /**
       * carta selezionata
       */
      this.currentCarta;

      /**
       * funzione selezionata.
       */
      this.currentFunzione;

      /**
       * funzione currentBlocco.
       */
      this.currentBlocco;

      /**
       * Dati valorizzati per il secondo step
       */
      this.datiAggiuntivi;

      /**
       * Definizione ndg
       */
      this.ndg;

      /**
       * Definizione id Target Market
       */
      this.idTargetMarket;

      /**
       * Definizione id pratica
       */
      this.idPratica;

      /**
       * Elenco dei conti per ndg.
       */
      this.elencoConti;

      /**
       * conto selezionato
       */
      this.currentConto;

      /**
       * Riferimento interno
       */
      var self = this;

      this.resetData = function () {
        self.elencoCarte = null;
        self.anagrafica = null;
        self.elencoFunzioni = null;
        self.currentCarta = null;
        self.currentFunzione = null;
        self.currentBlocco = null;
        self.ndg = null;
        self.elencoConti = null;
        self.currentConto = null;
        self.currentBlocco = null;
      };

      /**
       * Utility di formattazione date
       */
      this.millisToDate = function (milliseconds) {
        var data = new Date(milliseconds);

        if (!data) {
          return null;
        }

        var day = data.getDate();
        var month = data.getMonth() + 1;
        var year = data.getFullYear();

        return (
          (day < 10 ? '0' + day.toString() : day.toString()) +
          '/' +
          (month < 10 ? '0' + month.toString() : month.toString()) +
          '/' +
          year.toString()
        );
      };

      /**
       * Utility per separare il numero civico dall'indirizzo
       */
      this.civicoDaIndirizzo = function (indirizzo) {
        if (!(indirizzo && indirizzo.trim().length > 0)) {
          return null;
        }

        // split per ' ' (spazio)
        var viaSplit = indirizzo.split(' ');
        var splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        // split per ','
        viaSplit = indirizzo.split(',');
        splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        return null;
      };

      /**
       * Indica se la pratica è in sola lettura
       */
      this.praticaIsReadOnly = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
            return true;
          default:
            return false;
        }
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione pulsante indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione proseguimento. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "indietro" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di tornare indietro
       */
      this.indietroAbilitato = this.defaultIndietroAbilitato;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaVisibile = this.defaultSalvaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.proseguiVisibile = this.defaultProseguiVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "annulla" nel componente postVenditaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di annullare se la pratica non è in sola lettura
       */

      this.annullaVisibile = function () {
        return !self.praticaIsReadOnly();
      };

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "completa" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di completare
       */
      this.completaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
            return false;
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };
      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaAbilitato = this.defaultSalvaAbilitato;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.proseguiAbilitato = this.defaultProseguiAbilitato;

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Verifica se lo stato della pratica permette la navigazione tramite click sui tab
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        return self.praticaIsReadOnly();
      };

      /**
       * @ngdoc method
       * @name generaTabs
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Genera l'elenco delle tabs da visualizzare per la pratica
       * @return {Array} - Ritorna l'elenco delle tab disponibili per la pratica
       */
      this.generaTabs = function (hasProsegui) {
        var tabs = [];

        tabs.push({
          step: 'DEFINIZIONE',
          label: 'label.tab.postvendita.funzioni',
          posizione: '1',
          statoPratica: [
            {
              stato: 'DAREVISIONARE',
              step: 1
            },
            {
              stato: 'INCORSO',
              step: 1
            }
          ],
          sottoStep: null
        });

        if (hasProsegui) {
          tabs.push({
            step: 'DATIAGGIUNTIVI',
            label: 'label.tab.postvendita.dettagli',
            posizione: '2',
            statoPratica: [
              {
                stato: 'INCORSO',
                step: 2
              }
            ],
            sottoStep: null
          });
        }

        return tabs;
      };

      /**
       * Chiama servizio per recuperare i dati di una pratica già avviata
       * @param idPratica Id della pratica da recueperare
       */
      this.promiseRecuperaDati = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (
        ndg,
        carta,
        funzione,
        conto,
        nuovaIntestazione,
        tipoBlocco,
        importoQuota,
        cdMotivo,
        limiteGiornaliero,
        limiteMensile,
        downOption,
        idPratica,
        cartaLight,
        numeroRapporto,
        indirizzoSpedizione
      ) {
        // parametri fissi
        var data = {
          ndg: ndg,
          numeroCarta: carta,
          funzione: funzione,
          iban: conto,
          nuovaIntestazione: nuovaIntestazione,
          // Nexi prevede che se tipoBlocco non è settato, allora gli venga passato uno spazio vuoto
          // invece di passare null
          tipoBlocco: tipoBlocco ? tipoBlocco : ' ',
          importoQuota: importoQuota,
          codiceMotivo: cdMotivo,
          limiteGiornaliero: limiteGiornaliero,
          limiteMensile: limiteMensile,
          downOption: downOption,
          idPratica: idPratica,
          cartaLight: cartaLight,
          numeroRapporto: numeroRapporto,
          indirizzoSpedizione: indirizzoSpedizione
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CREA,
          data: data
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioPratica = function (ndg, idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.DETTAGLIO + ndg + '/' + idPratica
        });
      };

      /**
       * recupero dell'elenco delle carte da ndg
       * @param {*} idPratica
       */
      this.promiseElencoCarte = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CARTA_NDG + ndg
        });
      };

      /**
       * recupero dell'elenco delle carte da ndg
       * @param {*} idPratica
       */
      this.promiseElencoConti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CONTI_NDG + ndg + '/true'
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaFunzioni = function () {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.FUNZIONI
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPostVendita
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per annullare una pratica in postVendita
       * @return {Promise} - Ritorna una promise contenente il result dell'annullamento
       */
      this.promiseAnnullaPostVendita = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.ANNULLA.replace('{id}', idPratica)
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDominio = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAggiuntivi = function (idPratica, datiAggiuntivi, prosegui, sottostep) {
        var paramsObj = {
          prosegui: prosegui
        };

        if (sottostep && sottostep > 0) {
          paramsObj.sottostep = sottostep;
        }

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI,
          data: datiAggiuntivi,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseCompletaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.COMPLETA,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagraficaCoi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente la lista degli ndg anche delle COI
       */
      this.promiseRecuperaAnagraficaCoi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_COI + ndg
        });
      };
    }
  ]);
})();


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaDatiAggiuntivi
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaDatiAggiuntiviCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    postVenditaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.loggerSrvc = loggerSrvc;
    this.messaggiFctr = messaggiFctr;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.domainSrvc = domainSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Altezza della griglia carte
     */
    this.altezzaTabellaCarte = 0;

    /**
     * altezza griglia del conto corrente
     */
    this.altezzaTabellaConti = 0;

    /**
     * altezza griglia del conto corrente
     */
    this.altezzaTabellacurrentCarta = 0;

    /**
     * Altezza di una riga della griglia dei carte
     */
    this.altezzaRigaCarte = 30;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.postVenditaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone completo
     */
    this.postVenditaCartaDebitoIntSrvc.completaVisibile = function () {
      return !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone indietro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroVisibile = function () {
      return !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly();
    };

    /**
     * Implementazione nel service dell'abilitazione del bottone completa
     */
    this.postVenditaCartaDebitoIntSrvc.completaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return false;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO) {
        return !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentBlocco;
      } else if (
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.RIMUOVI_BLOCCO ||
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.DUP_CARTA ||
        self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.RIF_CARTA
      )
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentFunzione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.importoQuota &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.condizione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteGiornaliero &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteMensile &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.limiteDownoption
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INTESTA)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.nuovaIntestazione
        );
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO)
        return !!self.postVenditaCartaDebitoIntSrvc.currentCarta && !!self.postVenditaCartaDebitoIntSrvc.currentConto;
      else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO)
        return (
          !!self.postVenditaCartaDebitoIntSrvc.currentCarta &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.via &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.numero &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione &&
          !!self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita
        );
      return false;
    };

    function recuperaBlocco() {
      recuperaDominio(
        'recupero Blocco Carte', // per log
        CONSTANTS.REST.POST_VENDITA.ELENCO_BLOCCO, // funzione
        cllBckBlocco //cllBack
      );
    }

    function recuperaCondizioni() {
      recuperaDominio(
        'recupero Condizioni Carta', // per log
        CONSTANTS.REST.POST_VENDITA.ELENCO_CONDIZIONI, // funzione
        cllBckCond //cllBack
      );
    }

    function recuperaLimiti(prod) {
      recuperaDominio(
        'recupero Limiti Carta',
        CONSTANTS.REST.POST_VENDITA.ELENCO_LIMITI.replace('{codProdotto}', prod),
        cllBackLimiti
      );
    }

    function cllBckBlocco(response) {
      self.postVenditaCartaDebitoIntSrvc.elencoBlocco = response.data.result;
    }

    function cllBckCond(response) {
      self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = response.data.result;
    }

    function cllBackLimiti(response) {
      self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = response.data.result;
    }

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      // Se non ho indirizzo, lo prevalorizzo con i dati dall'anagrafica
      if (
        !self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi ||
        !self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione
      ) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
          indirizzoSpedizione: {
            via: null,
            numero: null,
            provincia: null,
            comune: {
              valore: null
            },
            cap: null,
            nazione: null,
            localita: null
          }
        };
      }

      $q.all([self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')])
        .then(function (responses) {
          self.paesi = responses[0];

          // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
          self.province = responses[1].filter(function (value) {
            return value.codice !== '**';
          });
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
          // indirizzo nazione spedizione forzato a ITALIA (086)
          self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.nazione =
            CONSTANTS.NAZIONE_SPEDIZIONE_DEFAULT;

          if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune != null) {
            self.recuperaComuni(false);
            self.recuperaCAP(false);
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function (pulisciValori) {
      self.spinner.showSpinner++;
      var comune = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
          if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita) {
            self.recuperaLocalita(false);
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function (pulisciValori) {
      self.spinner.showSpinner++;
      var cap = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap;
      var comune = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.citta;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:postVenditaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function (pulisciValori) {
      var provincia = '';
      provincia = self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.provincia;

      if (pulisciValori && self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione) {
        if (self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune) {
          self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.comune.valore = null;
        }

        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.cap = null;
        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione.localita = null;
      }

      if (!provincia) {
        self.comuni = [];
        return;
      }

      self.spinner.showSpinner++;
      recuperaComuniImpl(provincia).then(function (domain) {
        self.comuni = domain;
      });
    };

    function recuperaComuniImpl(provincia) {
      return self.domainSrvc.promiseDomain('COMUNE', provincia).finally(function () {
        if (self.spinner.showSpinner > 0) {
          self.spinner.showSpinner--;
        }
      });
    }

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     */
    function recuperaDominio(msgLog, fun, callback) {
      self.spinner.showSpinner++;

      // logging
      self.loggerSrvc.log('postVenditaDatiAggiuntiviCtrl', self.loggerSrvc.INFO, 'Inizio ' + msgLog);

      self.postVenditaCartaDebitoIntSrvc
        .promiseRecuperaDominio(fun)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (callback) callback(response);

            self.loggerSrvc.log('postVenditaDatiAggiuntiviCtrl', self.loggerSrvc.INFO, 'Termine ' + msgLog);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.SEVERE,
              'Errore ' + msgLog + self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    }

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.loadElencoCarteGrid = function (arrayCurrentCarta) {
      const defAltezzaTabellaCarte = 2;

      if (arrayCurrentCarta.length > defAltezzaTabellaCarte)
        self.altezzaTabellaCarte = defAltezzaTabellaCarte * self.altezzaRigaCarte + 60;
      else self.altezzaTabellaCarte = arrayCurrentCarta.length * self.altezzaRigaCarte + 60;

      self.carteGridOptions = {
        enableSorting: true,
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza',
            type: 'date',
            cellFilter: "date:'dd/MM/yyyy'"
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '8%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: arrayCurrentCarta
      };
    };

    /**
     * Funzione per caricare l'elenco dei conti collegati a ndg
     */
    this.loadElencoContiGrid = function () {
      const defAltezzaTabellaConti = 2;

      if (self.postVenditaCartaDebitoIntSrvc.elencoConti.length >= defAltezzaTabellaConti)
        self.altezzaTabellaConti = self.postVenditaCartaDebitoIntSrvc.elencoConti.length * self.altezzaRigaCarte + 40;
      else self.altezzaTabellaConti = defAltezzaTabellaConti * self.altezzaRigaCarte + 40;

      self.contiGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.rapporto'),
            field: 'numeroRapporto',
            width: '20%',
            name: 'numeroRapporto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.iban'),
            field: 'iban',
            width: '20%',
            name: 'iban'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.descrizione'),
            field: 'descrizione',
            width: '15%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.saldo'),
            field: 'saldo',
            width: '10%',
            name: 'saldo'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.intestatario'),
            field: 'intestatario',
            width: '10%',
            name: 'intestatario'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.stato'),
            field: 'stato',
            width: '10%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto.dataapertura'),
            field: 'dataApertura',
            cellFilter: "date:'dd/MM/yyyy'",
            width: '15%',
            name: 'dataApertura'
          }
        ],
        data: self.postVenditaCartaDebitoIntSrvc.elencoConti,
        onRegisterApi: function (gridApi) {
          gridApi.grid.modifyRows(self.contiGridOptions.data);

          // Se era già stato salvato il conto la recupero e seleziono
          if (self.postVenditaCartaDebitoIntSrvc.elencoConti && self.postVenditaCartaDebitoIntSrvc.currentIban) {
            angular.forEach(self.postVenditaCartaDebitoIntSrvc.elencoConti, function (conto, index) {
              if (conto.iban === self.postVenditaCartaDebitoIntSrvc.currentIban) {
                gridApi.selection.selectRow(self.postVenditaCartaDebitoIntSrvc.elencoConti[index]);
              }
            });
          }
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            self.selezionaConto(row);
          });
        }
      };
    };

    /**
     * Funzione per caricare la tabella della carta selezionata
     */
    this.loadCurrentCartaGrid = function () {
      const defAltezzaTabellaConti = 1;

      self.altezzaTabellacurrentCarta = defAltezzaTabellaConti * self.altezzaRigaCarte + 60;

      var listaCarte = [];
      // viene aggiunta alla lista da visualizzare solo carta selezionata nello step DEFINIZIONE
      listaCarte.push(self.postVenditaCartaDebitoIntSrvc.currentCarta);

      self.currentCartaGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '8%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: listaCarte
      };
    };

    /**
     * Funzione assegnata alla selezione di una riga di conto corrente
     */
    this.selezionaConto = function (conto) {
      if (conto.isSelected) {
        this.postVenditaCartaDebitoIntSrvc.currentConto = conto.entity;
        //Mappo sul campo idPraticaConto da restituire a BE il valore
        this.postVenditaCartaDebitoIntSrvc.currentConto.idPraticaConto = conto.entity.idPraticaProposta;
      } else this.postVenditaCartaDebitoIntSrvc.currentConto = null;
    };

    this.recuperaElencoConti = function (ndgList) {
      self.spinner.showSpinner++;
      var promiseList = [];
      for (var i = 0; i < ndgList.length; i++) {
        promiseList.push(self.postVenditaCartaDebitoIntSrvc.promiseElencoConti(ndgList[i]));
      }
      $q.all(promiseList)
        .then(
          function (responses) {
            if (self.messaggiFctr.processaResponse(responses)) {
              return;
            }

            self.postVenditaCartaDebitoIntSrvc.elencoConti = [];
            for (var responsesIndex = 0; responsesIndex < responses.length; responsesIndex++) {
              if (responses[responsesIndex].data && responses[responsesIndex].data.result) {
                for (var dataIndex = 0; dataIndex < responses[responsesIndex].data.result.length; dataIndex++) {
                  self.postVenditaCartaDebitoIntSrvc.elencoConti.push(responses[responsesIndex].data.result[dataIndex]);
                }
              }
            }

            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.INFO,
              'Recupeo con successo conti ndg ' + self.postVenditaCartaDebitoIntSrvc.ndg
            );

            self.loadElencoContiGrid();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'postVenditaDatiAggiuntiviCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero conti associati ndg ' +
                self.postVenditaCartaDebitoIntSrvc.ndg +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner = 0;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // nel caso in cui sono nella modifica del conto devo recuperare
        // dall'elenco dei conti tutti quelli con numero conto = a quello selezionato
        // e riproporli.
        if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO) {
          // cerco le carte con stesso conto.
          self.arrCarteFiltered = self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.filter(function (utenza) {
            return utenza.conto === self.postVenditaCartaDebitoIntSrvc.currentCarta.conto;
          });

          self.loadElencoCarteGrid(self.arrCarteFiltered);
        } else self.loadElencoCarteGrid([self.postVenditaCartaDebitoIntSrvc.currentCarta]);

        // in base alla funzione recupero i dati di dominio
        if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.ATTIVA_BLOCCO) recuperaBlocco();
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONDIZIONI)
          recuperaCondizioni();
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_INDIRIZZO) {
          self.recuperaDomini();
        } else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_LIMITI)
          recuperaLimiti(self.postVenditaCartaDebitoIntSrvc.currentCarta.codiceUtenza);
        // FIX inserisci il prodotto preso dalla riga.
        else if (self.postVenditaCartaDebitoIntSrvc.currentFunzione === CONSTANTS.FUNZIONI.MOD_CONTO) {
          self.postVenditaCartaDebitoIntSrvc.elencoConti = null;
          self.loadCurrentCartaGrid();
          self.spinner.showSpinner++;
          //          var listaConti = [];
          //          listaConti.push(self.postVenditaCartaDebitoIntSrvc.currentCarta);
          //
          //          self.loadElencoCarteGrid(listaConti);

          //EMonetica-829 - Recuperare gli ndg anche delle coi
          $q.all([
            self.postVenditaCartaDebitoIntSrvc.promiseRecuperaAnagraficaCoi(self.postVenditaCartaDebitoIntSrvc.ndg)
          ]).then(function (response) {
            var ndgList = [];
            if (response[0].data.result.length > 0) {
              console.log('Ndg trovati ' + response[0].data.result);
              angular.forEach(response[0].data.result, function (ndg, index) {
                ndgList.push(ndg);
              });
              console.log('Ndg inseriti ' + ndgList);
            }

            ndgList.push(self.postVenditaCartaDebitoIntSrvc.ndg);
            self.recuperaElencoConti(ndgList);
          });
          //              .finally(function () {
          //                if (self.spinner.showSpinner > 0) {
          //                  self.spinner.showSpinner = 0;
          //                }
          //              });
        }
      });
    };

    self.init();
  };

  PostVenditaDatiAggiuntiviCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'postVenditaCartaDebitoInt/postVenditaDatiAggiuntivi/postVenditaDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaDatiAggiuntiviComponent = {
    controller: PostVenditaDatiAggiuntiviCtrl,
    controllerAs: 'postVenditaDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaDatiAggiuntivi', PostVenditaDatiAggiuntiviComponent);
})();


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaDefinizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaDefinizioneCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    postVenditaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Numero della carta recuperato da chiamata
     */
    this.numeroCarta;

    /**
     * Array delle funzioni filtrato in base alla selezione della carta
     */
    this.elencoFunzioniFiltrato = [];

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * Definizione della griglia dei conti corrente
     */
    this.carteGridOptions = {};

    /**
     * Altezza della griglia dei conti corrente
     */
    this.altezzaTabellaCarte = 0;

    /**
     * Altezza di una riga della griglia dei conti corrente
     */
    this.altezzaRigaCarte = 30;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiVisibile = function () {
      // Per ora prosegui esiste solo per la funzione di blocco
      return (
        (!self.postVenditaCartaDebitoIntSrvc.currentFunzione ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'APLBLC' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODCNT' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODIND') &&
        !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly()
      );
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone indietro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroVisibile = function () {
      return false;
    };

    /**
     * implementazione del completa.
     */
    this.postVenditaCartaDebitoIntSrvc.completaVisibile = function () {
      // Per ora tutte le funzioni hanno 1 step tranne blocco
      return (
        self.postVenditaCartaDebitoIntSrvc.currentFunzione &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'APLBLC' &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'MODCNT' &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'MODIND'
      );
    };

    /**
     * Implementazione nel service della funzione di abilitazione indetro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroAbilitato = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione completa pratica
     */
    this.postVenditaCartaDebitoIntSrvc.completaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return !!self.postVenditaCartaDebitoIntSrvc.currentFunzione && !!self.postVenditaCartaDebitoIntSrvc.currentCarta;
    };

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.loadElencoCarteGrid = function () {
      const defAltezzaTabellaCarte = 5;

      if (self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.length > defAltezzaTabellaCarte)
        self.altezzaTabellaCarte = defAltezzaTabellaCarte * self.altezzaRigaCarte + 40;
      else
        self.altezzaTabellaCarte =
          self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.length * self.altezzaRigaCarte + 40;

      if (self.numeroCarta) {
        var cardSearch = self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.filter(function (carta) {
          return carta.numeroCarta === self.numeroCarta;
        });
        if (cardSearch.length > 0) {
          self.postVenditaCartaDebitoIntSrvc.currentCarta = cardSearch[0];
        }
      }

      self.carteGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza',
            type: 'date',
            cellFilter: "date:'dd/MM/yyyy'"
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '10%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte,
        onRegisterApi: function (gridApi) {
          gridApi.grid.modifyRows(self.carteGridOptions.data);

          // Se era già stato salvato la carta la recupero e seleziono
          if (self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte && self.postVenditaCartaDebitoIntSrvc.currentCarta) {
            angular.forEach(self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte, function (carta, index) {
              if (carta.numeroCarta === self.postVenditaCartaDebitoIntSrvc.currentCarta.numeroCarta) {
                gridApi.selection.selectRow(self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte[index]);
              }
            });
          }

          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            self.selezionaCarta(row);
          });
        }
      };
    };

    // private function
    function loadSpinnerAndLog(logmessage) {
      self.spinner.showSpinner++;

      self.loggerSrvc.log('postVenditaDefinizioneCtrl', self.loggerSrvc.INFO, logmessage);
    }

    this.recuperaElencoCarte = function (ndg) {
      if (!!self.postVenditaCartaDebitoIntSrvc.elencoCarte) {
        self.loadElencoCarteGrid();
      } else {
        // logging
        loadSpinnerAndLog('recupero Carte per NDG ' + ndg);
        // call service per elencoCarte
        self.postVenditaCartaDebitoIntSrvc
          .promiseElencoCarte(ndg)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }
              self.postVenditaCartaDebitoIntSrvc.elencoCarte = response.data.result;

              self.postVenditaCartaDebitoIntSrvc.anagrafica = response.data.result.anagrafica;

              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.INFO,
                'recuperate con successo carte per ndg ' + ndg
              );

              self.loadElencoCarteGrid();
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason);
              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.SEVERE,
                'Errore durante la creazione della per NDG ' +
                  ndg +
                  ' e Prodotto ' +
                  self.idProdotto +
                  ': ' +
                  self.loggerSrvc.formattaMessaggio(reason)
              );
            }
          )
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    /**
     * Funzione chiamata al cambio di funzione selezionata
     */
    this.onFunzioneChange = function () {
      $scope.$emit('onFunzioneChange');
    };

    /**
     * Funzione assegnata alla selezione di una riga di utenze
     * @param carta Carta selezionata nella tabella
     */
    this.selezionaCarta = function (carta) {
      // Reset della funzione selezionata se cambio lo stato
      // Non ha senso senza i filtri, decommentare in caso di reintroduzione dei filtri
      // if (
      //   self.postVenditaCartaDebitoIntSrvc.currentCarta &&
      //   self.postVenditaCartaDebitoIntSrvc.currentCarta.stato !== carta.entity.stato
      // ) {
      //   self.postVenditaCartaDebitoIntSrvc.currentFunzione = '';
      // }
      // Se ho selezionato qualcosa imposto currentCarta e filtro le funzioni
      if (carta.isSelected) {
        self.postVenditaCartaDebitoIntSrvc.currentCarta = carta.entity;
        // Nota: i filtri lato FE sono stati annullati per ora, decommentare il codice sottostante per
        // reinserirli

        // var filter = self.getFiltroFunzioni(carta.entity.stato);
        // // Se filter è popolato allora lo usa per filtrare, altrimenti imposta lista vuota
        // if (filter) {
        //   self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni.filter(function (funzione) {
        //     return funzione.codice === filter;
        //   });
        // } else {
        //   self.elencoFunzioniFiltrato = [];
        // }
      } else {
        // Se non ho selezionato nessuna carta imposto currentCarta a null e ripristino l'elenco funzioni
        // a quello originale completo
        self.postVenditaCartaDebitoIntSrvc.currentCarta = null;
        // Decommenta per reinserire i filtri
        // self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni;
      }
    };

    /**
     * Passando lo stato di una carta restituisce il filtro da applicare all'elenco funzioni
     * @param stato Stato della carta per cui filtrare
     */
    this.getFiltroFunzioni = function (stato) {
      var filter = '';
      switch (stato) {
        // Bloccata
        case 'BL':
          filter = 'RMZBLC';
          break;
        // Attiva
        case 'AT':
          filter = 'APLBLC';
          break;
        // Codice non trovato
        default:
          filter = '';
      }
      return filter;
    };

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     */
    this.recuperaFunzioni = function () {
      // logging
      loadSpinnerAndLog('recupero funzioni NDG ');
      self.postVenditaCartaDebitoIntSrvc
        .promiseRecuperaFunzioni()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.postVenditaCartaDebitoIntSrvc.elencoFunzioni = response.data.result;
            self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni;

            self.loggerSrvc.log('PostVenditaCartaDebitoIntCtrl', self.loggerSrvc.INFO, 'Recupero delle funzioni ');
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'PostVenditaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero funzioni per NDG ' +
                self.ndg +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
          indirizzoSpedizione: {
            via: null,
            numero: null,
            provincia: null,
            comune: {
              valore: null
            },
            cap: null,
            nazione: null,
            localita: null
          }
        };

        self.postVenditaCartaDebitoIntSrvc.idPratica = self.$stateParams.idPratica;
        if (self.postVenditaCartaDebitoIntSrvc.idPratica) {
          self.spinner.showSpinner++;
          self.postVenditaCartaDebitoIntSrvc
            .promiseRecuperaDati(self.postVenditaCartaDebitoIntSrvc.idPratica)
            .then(function (response) {
              if (response && response.data && response.data.result) {
                self.postVenditaCartaDebitoIntSrvc.currentFunzione = response.data.result.funzione;
                self.numeroCarta = response.data.result.numeroCarta;
                self.postVenditaCartaDebitoIntSrvc.currentBlocco = response.data.result.tipoBlocco;
                self.postVenditaCartaDebitoIntSrvc.currentIban = response.data.result.iban;

                self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
                  indirizzoSpedizione: {
                    via: null,
                    numero: null,
                    provincia: null,
                    comune: {
                      valore: null
                    },
                    cap: null,
                    nazione: null,
                    localita: null
                  }
                };

                self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione =
                  response.data.result.indirizzoSpedizione;

                self.postVenditaCartaDebitoIntSrvc.datiPratica = {
                  stato: response.data.result.proposta.stato,
                  step: response.data.result.proposta.step
                };

                // load delle carte.
                self.recuperaElencoCarte(self.postVenditaCartaDebitoIntSrvc.ndg);

                if (self.postVenditaCartaDebitoIntSrvc.currentFunzione) {
                  self.onFunzioneChange();
                }
              }
            })
            .finally(function () {
              if (self.spinner.showSpinner > 0) {
                self.spinner.showSpinner--;
              }
            });
        }else{
        	// load delle carte.
            self.recuperaElencoCarte(self.postVenditaCartaDebitoIntSrvc.ndg);
        }

        // carico le funzioni attraverso il servizio.
        self.recuperaFunzioni();
      });
    };

    self.init();
  };

  PostVenditaDefinizioneCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'postVenditaCartaDebitoInt/postVenditaDefinizione/postVenditaDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaDefinizioneComponent = {
    controller: PostVenditaDefinizioneCtrl,
    controllerAs: 'postVenditaDefinizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaDefinizione', PostVenditaDefinizioneComponent);
})();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:reqLottCartaDebitoInt
 * @restrict E
 * @description Componente per la visualizzazione di richiesta lotto
 */
(function () {
  'use strict';
  var ReqLottCartaDebitoIntCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    domainSrvc,
    reqLottCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.reqLottCtrl = this;

    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.domainSrvc = domainSrvc;
    this.reqLottCartaDebitoIntSrvc = reqLottCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Istanza della Form di richiesta lotto
     */
    this.formReqlott;

    /**
     * Tendina provincie.
     */
    this.province = [];

    /**
     * Tendina comuni.
     */
    this.comuni = [];

    /**
     * Tendina cap.
     */
    this.cap = [];

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.reqLottCartaDebitoIntSrvc.spinner;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione del pulsante "richiedi"
     */
    this.reqLottCartaDebitoIntSrvc.richiediAbilitato = function () {
      return self.formValido();
    };

    this.avanza = function () {
      if (this.formReqlott.$valid) {
        // Chiamata al be MF per sottomettere la richiesta
        self.richiestaReqLott();
      }
    };

    this.richiestaReqLott = function () {
      // invio i dati per richiesta
      self.spinner.showSpinner = true;

      return self.reqLottCartaDebitoIntSrvc
        .promiseRichiesta(
          self.reqLottCartaDebitoIntSrvc.currentProdotto,
          self.reqLottCartaDebitoIntSrvc.currentNumeroCarte,
          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }
            self.reqLottCartaDebitoIntSrvc.resetData();
            self.$state.go('home', { ndg: null });
          },
          function (reason) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(reason);
          }
        );
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        // devono essere riempiti
        !!self.reqLottCartaDebitoIntSrvc.currentNumeroCarte &&
        !!self.reqLottCartaDebitoIntSrvc.currentProdotto &&
        // devono essere numerici
        angular.isNumber(self.reqLottCartaDebitoIntSrvc.currentNumeroCarte) &&
        self.reqLottCartaDebitoIntSrvc.currentNumeroCarte > 0
      );
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function() {
      var provincia = self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia;
      if (provincia == null) {
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune = null;
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
        return;
      }

      self.spinner.showSpinner = true;

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;

          // Se il valore comune è pre valorizzato correttamente procedo il caricamento dei CAP
          if (self.isProcessNextList(self.comuni, self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune)) {
            self.recuperaCAP();
            return;
          }

          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune = null;
          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
          self.spinner.showSpinner = false;
        }, function(reason) {
          console.error(reason);
          self.spinner.showSpinner = false;
        });
    }

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      var comune = self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.comune;
      if (comune == null) {
        self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;
        return;
      }

      self.spinner.showSpinner = true;

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;

          if (self.isProcessNextList(self.cap, self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap)) {
            return;
          }

          self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.cap = null;

        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name isProcessNextList
     * @methodOf cbl.cartadebitoint.wa:reqLottCartaDebitoInt
     * @description Torna true se il valore è in lista è presente in lista.
     */
    this.isProcessNextList = function(list , value) {
      if (value == null) {
        return false;
      }

      var selected = list.filter(function(item) {
        return value === item.codice;
      });

      return selected.length > 0;
    }

    /**
     * ===== GESTIONE BOTTONIERA A PIÉ DI PAGINA =====
     */

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display: none;');
      }

      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // recupero delle carte per il codice prodotto
        self.spinner.showSpinner = true;
        $q.all([
          self.domainSrvc.promiseDomain('PROVINCIA'),
          self.reqLottCartaDebitoIntSrvc.promiseRecuperaIndirizzoDefault(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
          // self.reqLottCartaDebitoIntSrvc.promiseRecuperaDominio(CONSTANTS.REST.REQ_LOTT.RECUPERA_LISTA_PRODOTTI),
          self.reqLottCartaDebitoIntSrvc.promiseRecuperaIndirizzoDefault(
            CONSTANTS.REST.REQ_LOTT.RECUPERA_INDIRIZZI_DEFAULT
          )
        ]).then(
          function (response) {
            self.province = response[0];

            // Rimuovo stato estero perché indirizzo di spedizione è sempre italia
            self.province = response[0].filter(function (value) {
              return value.codice !== '**';
            });

            self.reqLottCartaDebitoIntSrvc.elencoProdotto = response[1].data.result;
            self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione = response[2].data.result;

            // Se la provincia è pre valorizzata in modo corretto procedo con il caricamento dei comuni
            if (self.isProcessNextList(self.province,
                                       self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia)) {
              self.recuperaComuni();
              return;
            }
            self.reqLottCartaDebitoIntSrvc.currentIndirizzoSpedizione.provincia = null;
            self.spinner.showSpinner = false;
          },
          function (reason) {
            console.error(reason);
            self.spinner.showSpinner = false;
          }
        );
      });
    };

    self.init();
  };


  ReqLottCartaDebitoIntCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'CdintDomainSrvc',
    'ReqLottCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'reqLottCartaDebitoInt/reqLottCartaDebitoInt.html';
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var ReqLottCartaDebitoIntComponent = {
    controller: ReqLottCartaDebitoIntCtrl,
    controllerAs: 'reqLottCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('reqLottCartaDebitoInt', ReqLottCartaDebitoIntComponent);
})();


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:reqLottCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione lotto richiesta carte
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('ReqLottCartaDebitoIntSrvc', [
    '$http',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * numero delle carte richiesto per la richiesta
       */
      this.currentNumeroCarte;

      /**
       * prodotto selezionato.
       */
      this.currentProdotto;

      /**
       * elenco dei prodotti.
       */
      this.elencoProdotto;
      
      /**
       * indirizzo spedizione.
       */
      this.currentIndirizzoSpedizione;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: false };

      /**
       * Riferimento interno
       */
      var self = this;

      this.resetData = function () {
        self.currentNumeroCarte = null;
        self.currentProdotto = null;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione del pulsante "richiedi". Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultRichiediAbilitato = function () {
        return false;
      };

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.richiediVisibile = this.defaultRichiediVisibile;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "richiedi" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.richiediAbilitato = this.defaultRichiediAbilitato;

      /**
       * @ngdoc method
       * @name promiseRecuperaIndirizzoDefault
       * @methodOf cbl.cartadebitoint.wa.directive:ReqLottCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare l' indirizzo di default
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi inerenti l' indirizzo di default
       */
      this.promiseRecuperaIndirizzoDefault = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:ReqLottCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDominio = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseRichiesta
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseRichiesta = function (codProdotto, numeroCarte, indirizzoSpedizione) {
        // parametri fissi
        var data = {
          codProdotto: codProdotto,
          numeroCarte: numeroCarte,
          datiFiliale: indirizzoSpedizione
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.REQ_LOTT.CREA_RICHIESTA,
          data: data
        });
      };
    }
  ]);
})();


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.cartadebitoint.wa').service('CdintDomainSrvc', [
    '$http',
    '$q',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    function($http, $q, messaggiFctr, CONSTANTS) {
      this.domains = {};

      this.getDomain = function(domain, skipBlank, filter) {
        if (this.domains === undefined) {
          this.domains = {};
        }
        if (
          this.domains[domain] === undefined ||
          this.domains[domain].length === 0
        ) {
          // chiamata Rest al servizio di recupero dominio in caso non sia
          // gia' memorizzato
          var self = this;
          $http({
            method: 'GET',
            url:
              CONSTANTS.REST_ROOT +
              CONSTANTS.REST.DOMINI +
              domain.toUpperCase(),
            params: {
              filtro: filter
            }
          }).then(
            function(response) {
              if (messaggiFctr.processaResponse(response)) {
                return;
              }
              self.domains[domain] = [];
              if (!skipBlank) {
                self.domains[domain].push({
                  key: '',
                  value: 'Seleziona...'
                });
              }
              for (var i in response.data.result) {
                self.domains[domain].push(response.data.result[i]);
              }
            },
            function(reason) {
              messaggiFctr.processaResponse(reason);
            }
          );
        }
        return this.domains[domain];
      };

      this.promiseDomain = function(domain, params) {
        var deferred = $q.defer();

        var self = this;
        $http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI + domain.toUpperCase(),
          params: {
            filtro: params
          }
        }).then(
          function(response) {
            if (messaggiFctr.processaResponse(response)) {
              return;
            }
            self.domains[domain] = [];

            for (var j in response.data.result) {
              self.domains[domain].push(response.data.result[j]);
            }

            deferred.resolve(self.domains[domain]);
          },
          function(reason) {
            deferred.reject(reason);
            messaggiFctr.processaResponse(reason);
          }
        );

        return deferred.promise;
      };

      this.getLabel = function(domain, key) {
        if (!this.domains) {
          return '';
        }
        var array = this.domains[domain];
        if (!array) {
          return '';
        }
        for (var i in array) {
          if (array[i].cod === key) {
            return array[i].dsc;
          }
        }
        return '';
      };
    }
  ]);
})();


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 *
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('CdintLabelSrvc', [
    function () {
      this.labels = [];
      var self = this;
      this.develop = true;
      this.loading = true;
      this.labelsPronte;

      this.getLabel = function (label) {
        var res = self.labels[label];
        if (res === undefined || res === '') {
          res = 'UNDEFINED LABEL';
          if (self.develop) {
            res += ' [' + label + ']';
          }
        }
        return res;
      };
    },
  ]);
})();


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.cartadebitoint.wa').service('CdintLoggerSrvc', [
    '$http',
    'CDINT_CONSTANTS',
    function($http, CONSTANTS) {
      /**
       * Constants
       */
      this.SEVERE = 'SEVERE';
      this.WARNING = 'WARNING';
      this.INFO = 'INFO';
      this.CONFIG = 'CONFIG';
      this.FINE = 'FINE';
      this.FINER = 'FINER';
      this.FINEST = 'FINEST';
      var LEVELS = [
        this.FINEST,
        this.FINER,
        this.FINE,
        this.CONFIG,
        this.INFO,
        this.WARNING,
        this.SEVERE
      ];

      /**
       * Default value
       */
      this.loggerLevelString = this.FINEST;

      this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);

      this.setupLogger = function(baseLevel) {
        if (LEVELS.indexOf(baseLevel) !== -1) {
          this.loggerLevelString = baseLevel;
        }
        this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
      };

      this.levelEnabled = function(level) {
        return this.loggerLevel <= LEVELS.indexOf(level);
      };

      this.formattaMessaggio = function(logPayload) {
        var message = '';
        if (typeof logPayload !== 'string') {
          if (Object.prototype.toString.call(logPayload) === '[object Array]') {
            for (var idx in logPayload) {
              if (typeof logPayload[idx] === 'string') {
                message += ' ' + logPayload[idx];
              } else {
                message += ' ' + JSON.stringify(logPayload[idx]);
              }
            }
          } else {
            message += JSON.stringify(logPayload);
          }
          return message;
        } else {
          return logPayload;
        }
      };

      this.log = function(controller, type, message) {
        message = this.formattaMessaggio(message);

        var level = LEVELS.indexOf(type);

        if (level < this.loggerLevel) {
          return;
        }

        $http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
          data: {
            level: type,
            msg: message,
            ctrl: controller
          }
        });
      };
    }
  ]);
})();


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.cartadebitoint.wa').factory('CdintMessaggiFctr', [
    'CblMessageSrvc',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    function(messaggiSrvc, labelSrvc, loggerSrvc) {
      var processaResponse = function(response) {
        if (response.length > 0) {
          var respError;
          for (var index in response) {
            respError = this.processaResponse(response[index]);
            if (respError) {
              return true;
            }
          }
          return false;
        }

        if (
          response.data.messageList &&
          response.data.messageList.errMessages &&
          response.data.messageList.errMessages.length === 0 &&
          (response.data.result === null || response.data.result === undefined)
        ) {
          var message = {
            message: 'Nessuna risposta ricevuta dal servizio'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = false;

        if (response.data && response.data.messageList) {
          // Fatal
          if (
            response.data.messageList.fatMessages &&
            response.data.messageList.fatMessages.length > 0
          ) {
            for (var i in response.data.messageList.fatMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.fatMessages[i].message
              );
              console.error(response.data.messageList.fatMessages[i].message);
            }
            hasError = response.data.messageList.fatMessages.length > 0;
          }

          // Errori
          if (
            response.data.messageList.errMessages &&
            response.data.messageList.errMessages.length > 0
          ) {
            for (var i in response.data.messageList.errMessages) {
              messaggiSrvc.pushErrorMessage(
                response.data.messageList.errMessages[i].message
              );
              console.error(response.data.messageList.errMessages[i].message);
            }
            hasError =
              hasError || response.data.messageList.errMessages.length > 0;
          }

          // Warning
          if (
            response.data.messageList.warMessages &&
            response.data.messageList.warMessages.length > 0
          ) {
            for (var k in response.data.messageList.warMessages) {
              messaggiSrvc.pushWarningMessage(
                response.data.messageList.warMessages[k].message
              );
            }
          }

          // Info
          if (
            response.data.messageList.infMessages &&
            response.data.messageList.infMessages.length > 0
          ) {
            for (var z in response.data.messageList.infMessages) {
              messaggiSrvc.pushInfoMessage(
                response.data.messageList.infMessages[z].message
              );
            }
          }
        }
        if (response.status === 504) {
          messaggiSrvc.pushErrorMessage(
            labelSrvc.getLabel('errors.gatewaytimeout')
          );
          return true;
        }
        if (response.status > 399) {
          var messageHttp = {
            message: 'Error ' + response.status + ' ' + response.statusText
          };
          messaggiSrvc.pushErrorMessage(messageHttp.message);
        }
        return hasError;
      };

      var addMessage = function(message) {
        if (message.type === 'E' || message.type === 'F') {
          messaggiSrvc.pushErrorMessage(message.message);
        } else if (message.type === 'W') {
          messaggiSrvc.pushWarningMessage(message.message);
        } else {
          messaggiSrvc.pushInfoMessage(message.message);
        }
      };

      var resetMessages = function() {
        messaggiSrvc.reset();
      };

      return {
        processaResponse: processaResponse,
        addMessage: addMessage,
        resetMessages: resetMessages
      };
    }
  ]);
})();


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 *
 */
(function(window, undefined) {
  'use strict';
  var CdintUserSrvc = function() {
    this.user;
    this.abilitazioni;
    this.abilitazioniPronte;
    this.labelsPronte;
  };

  CdintUserSrvc.$inject = [];

  angular
    .module('cbl.cartadebitoint.wa')
    .service('CdintUserSrvc', CdintUserSrvc);
})(window);


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * 
 */
;
(function(){
	"use strict";
	angular.module("cbl.cartadebitoint.wa.directives", ["cbl.common"]);
	
}());

/***/ }),
/* 30 */
/***/ (function(module, exports) {

(function() {
  'use strict';
  angular
    .module('cbl.cartadebitoint.wa.directives')
    .directive('cdintSpinnerDrct', [
      'CDINT_CONSTANTS',
      function(CONSTANTS) {
        var link = function(scope, elem, attrs, model) {};

        var controller = function($scope) {
          this.getSpinnerUrl = function() {
            var url = null;
            var currentScope = $scope;
            do {
              url = currentScope.srcSpinner;
              currentScope = currentScope.$parent;
            } while (url === undefined && currentScope !== null);
            return url;
          };
        };

        controller.$inject = ['$scope'];
        return {
          restrict: 'E',
          scope: {},
          templateUrl:
            CONSTANTS.BASE_ROOT + 'widgets/cdintSpinner/cdintSpinner.html',
          controller: controller,
          controllerAs: 'spinner',
          link: link
        };
      }
    ]);
})();


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module
 */
__webpack_require__(1);

/**
 * Constants
 */
__webpack_require__(0);

/**
 * Directives
 */
__webpack_require__(29);
__webpack_require__(30);

/**
 * Services
 */

__webpack_require__(25);
__webpack_require__(27);
__webpack_require__(24);
__webpack_require__(28);
__webpack_require__(26);

/**
 * Services
 */
__webpack_require__(13);
__webpack_require__(19);
__webpack_require__(23);
__webpack_require__(17);

/**
 * Components
 */
__webpack_require__(10);
__webpack_require__(11);

__webpack_require__(6);
__webpack_require__(7);
__webpack_require__(5);
__webpack_require__(4);
__webpack_require__(8);
__webpack_require__(15);
__webpack_require__(9);
__webpack_require__(14);

__webpack_require__(12);
// postvendita
__webpack_require__(18);
__webpack_require__(21);
__webpack_require__(20);

// reqLott
__webpack_require__(22);

//inquiryLott
__webpack_require__(16);

/**
 * Run
 */
__webpack_require__(3);

/**
 * Config
 */
__webpack_require__(2);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.min.js